
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2TzCj", function(module, exports) {

var $6iWVH = parcelRequire("6iWVH");

function $c594f0c4919c867d$export$f50ba6ebca86afae(action) {
    return action.handleType === (0, $6iWVH.HandleActionType).Chat;
}
function $c594f0c4919c867d$export$e0faf22bf5023c5e(action) {
    return action.handleType === (0, $6iWVH.HandleActionType).Nested;
}
function $c594f0c4919c867d$export$ce07703e397785f3(action) {
    return action.handleType === (0, $6iWVH.HandleActionType).Skill;
}
function $c594f0c4919c867d$export$38d6fa0daaae0008(action) {
    return action.handleType === (0, $6iWVH.HandleActionType).Skill && 'dynamicPrompt' in action && (0, $6iWVH.LEGACY_DYNAMIC_SKILL_IDS).has(action.id);
}
function $c594f0c4919c867d$export$426fd22b878fe58d(action) {
    return $c594f0c4919c867d$export$f50ba6ebca86afae(action) || $c594f0c4919c867d$export$e0faf22bf5023c5e(action) || $c594f0c4919c867d$export$ce07703e397785f3(action);
}
module.exports["isChatAction"] = $c594f0c4919c867d$export$f50ba6ebca86afae;
module.exports["isNestedAction"] = $c594f0c4919c867d$export$e0faf22bf5023c5e;
module.exports["isSkillAction"] = $c594f0c4919c867d$export$ce07703e397785f3;

});

parcelRegister("iiDOK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $iehIX = parcelRequire("iehIX");

const $921dd5c9e20b74d2$export$b97fe97a2a407fce = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)((0, $iehIX.SplitViewContext));
} : ()=>(0, $cozmU.useContext)((0, $iehIX.SplitViewContext));
module.exports["useSplitView"] = $921dd5c9e20b74d2$export$b97fe97a2a407fce;

});

parcelRegister("iehIX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jEK83 = parcelRequire("jEK83");

const $d2139e3561c828e8$var$openWithRequestedPresentation = (requestedPresentation)=>requestedPresentation;
const $d2139e3561c828e8$export$9dcf8f238ea334c6 = /*#__PURE__*/ (0, $cozmU.createContext)({
    presentation: null,
    openSessionContext: $d2139e3561c828e8$var$openWithRequestedPresentation,
    closeSessionContext: (0, (/*@__PURE__*/$parcel$interopDefault($jEK83)))
});
module.exports["SplitViewContext"] = $d2139e3561c828e8$export$9dcf8f238ea334c6;

});

parcelRegister("5uiWK", function(module, exports) {

var $6iWVH = parcelRequire("6iWVH");

const $f650f5d03c59255a$var$supportedPageContextTypes = [
    (0, $6iWVH.PageContextType).CONFLUENCE_PAGE_VIEW,
    (0, $6iWVH.PageContextType).CONFLUENCE_PAGE_EDIT
];
const $f650f5d03c59255a$export$c2a686cb0530eec8 = (pageContextType)=>{
    return $f650f5d03c59255a$var$supportedPageContextTypes.includes(pageContextType);
};
module.exports["isPageContextTypeSupportedForDynamicStarters"] = $f650f5d03c59255a$export$c2a686cb0530eec8;

});

parcelRegister("bQmvI", function(module, exports) {

var $6iWVH = parcelRequire("6iWVH");

const $1fc19c5e39a1bbf3$export$10c6f1bef31d587c = [
    'database',
    'embed',
    'folder'
];
const $1fc19c5e39a1bbf3$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ($1fc19c5e39a1bbf3$export$10c6f1bef31d587c.includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
const $1fc19c5e39a1bbf3$export$ee833111bcbf78d7 = (url, pageContextType)=>{
    if (pageContextType === (0, $6iWVH.PageContextType).CONFLUENCE_PAGE_EDIT || pageContextType === (0, $6iWVH.PageContextType).CONFLUENCE_BLOG_EDIT) {
        // Match: /pages/edit-v2/{resourceId} or /blog/edit-v2/{resourceId}
        const match = url.match(/\/(?:pages|blog)\/edit-v2\/(\d+)/);
        return match ? match[1] : null;
    }
    if (pageContextType === (0, $6iWVH.PageContextType).CONFLUENCE_PAGE_VIEW) {
        // Page pattern: /pages/{resourceId}/
        const match = url.match(/\/pages\/(\d+)(?:\/|$|[?#])/);
        return match ? match[1] : null;
    }
    if (pageContextType === (0, $6iWVH.PageContextType).CONFLUENCE_BLOG_VIEW) {
        // Blog pattern: /blog/{year}/{month}/{day}/{resourceId}/
        const match = url.match(/\/blog\/\d{4}\/\d{2}\/\d{2}\/(\d+)/);
        return match ? match[1] : null;
    }
    return null;
};
const $1fc19c5e39a1bbf3$export$3bb5b6748490a3c9 = (siteId, contentUrl, pageContextType)=>{
    const resourceId = $1fc19c5e39a1bbf3$export$ee833111bcbf78d7(contentUrl, pageContextType);
    if (!resourceId) return null;
    const isBlogPost = /\/spaces\/[^\/]+\/blog\//.test(contentUrl);
    const resourceType = isBlogPost ? 'blogpost' : 'page';
    return $1fc19c5e39a1bbf3$export$6a2f2c83863e9bfe({
        siteId: siteId,
        resourceType: resourceType,
        activationId: '',
        resourceId: // Not needed for pages/blogposts
        resourceId
    });
};
module.exports["getContentAri"] = $1fc19c5e39a1bbf3$export$3bb5b6748490a3c9;

});

parcelRegister("lFQjm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");

const $d4fc531cc0ae7b89$export$46133998910543ac = (0, $cozmU.createContext)(null);
const $d4fc531cc0ae7b89$export$6fa751d66e55d2e1 = (usePathname)=>{
    const [location, setLocation] = (0, $cozmU.useState)(usePathname ? window.location.pathname : window.location.href);
    // For easier mocking
    const contextValue = (0, $cozmU.useContext)($d4fc531cc0ae7b89$export$46133998910543ac);
    const handleLocationChange = (0, $cozmU.useCallback)(()=>{
        const newValue = usePathname ? window.location.pathname : window.location.href;
        if (newValue !== location) setLocation(newValue);
    }, [
        location,
        setLocation,
        usePathname
    ]);
    (0, $cozmU.useEffect)(()=>{
        const originalPushState = window.history.pushState;
        const originalReplaceState = window.history.replaceState;
        window.history.pushState = function(...args) {
            originalPushState.apply(this, args);
            handleLocationChange();
        };
        window.history.replaceState = function(...args_0) {
            originalReplaceState.apply(this, args_0);
            handleLocationChange();
        };
        const unbind = (0, $cbY7C.bindAll)(window, [
            {
                type: 'popstate',
                listener: handleLocationChange
            }
        ]);
        return ()=>{
            unbind();
            window.history.pushState = originalPushState;
            window.history.replaceState = originalReplaceState;
        };
    }, [
        handleLocationChange
    ]);
    return contextValue ?? location;
};
module.exports["useWindowLocation"] = $d4fc531cc0ae7b89$export$6fa751d66e55d2e1;

});

parcelRegister("csz0J", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $cXtTj = parcelRequire("cXtTj");


var $jXXTm = parcelRequire("jXXTm");


var $mfdwv = parcelRequire("mfdwv");


var $f0b2F = parcelRequire("f0b2F");


var $1TvTa = parcelRequire("1TvTa");


var $5n93X = parcelRequire("5n93X");


var $aooxV = parcelRequire("aooxV");


var $4s4Os = parcelRequire("4s4Os");


var $hAgam = parcelRequire("hAgam");


var $11OF7 = parcelRequire("11OF7");


var $9KSWX = parcelRequire("9KSWX");


var $iDrrr = parcelRequire("iDrrr");


var $6iWVH = parcelRequire("6iWVH");


var $lFQjm = parcelRequire("lFQjm");


var $7HZZ5 = parcelRequire("7HZZ5");


var $en9ZE = parcelRequire("en9ZE");

const $ae28fc22beba689b$export$c6a4ebf596b0c08a = {
    [(0, $6iWVH.PageContextType).BITBUCKET_CREATE_PULL_REQUEST]: [
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).bitbucketCreatePullRequestsPrompt1
        }
    ],
    [(0, $6iWVH.PageContextType).BITBUCKET_PULL_REQUEST]: [
        {
            labelType: 'summarize-information',
            message: (0, $en9ZE.default).bitbucketPullRequestsPrompt1
        },
        {
            labelType: 'summarize-code',
            message: (0, $en9ZE.default).bitbucketPullRequestsPrompt4
        },
        {
            labelType: 'analyze-content',
            message: (0, $en9ZE.default).bitbucketPullRequestsPrompt3
        },
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).bitbucketPullRequestsPrompt5
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).bitbucketPullRequestsPrompt6
        }
    ],
    [(0, $6iWVH.PageContextType).BITBUCKET_REPOSITORY_SOURCE]: [
        {
            labelType: 'summarize-code',
            message: (0, $en9ZE.default).bitbucketRepositorySourcePrompt1
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).bitbucketRepositorySourcePrompt4
        },
        {
            labelType: 'code-search',
            message: (0, $en9ZE.default).bitbucketRepositorySourcePrompt5
        }
    ],
    [(0, $6iWVH.PageContextType).BITBUCKET_PIPELINES]: [
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).bitbucketPipelinePrompt1
        }
    ],
    [(0, $6iWVH.PageContextType).BITBUCKET]: [
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).bitbucketPrompt5
        },
        {
            labelType: 'check-status',
            message: (0, $en9ZE.default).bitbucketPrompt6
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).bitbucketPrompt7
        }
    ],
    [(0, $6iWVH.PageContextType).CONFLUENCE_HOME]: [
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).confluenceHomePrompt1
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).confluenceHomePrompt2
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).confluenceHomePrompt3
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).confluenceHomePrompt4
        },
        {
            labelType: 'rephrase-content',
            message: (0, $en9ZE.default).confluenceHomePrompt5
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).confluenceHomePrompt6
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).confluenceHomePrompt7
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).confluenceHomePrompt8
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).confluenceHomePrompt9
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).confluenceHomePrompt10
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).confluenceHomePrompt11
        }
    ],
    [(0, $6iWVH.PageContextType).CONFLUENCE_PAGE_VIEW]: [
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).confluencePageViewPrompt1
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).confluencePageViewPrompt2
        },
        {
            labelType: 'rephrase-content',
            message: (0, $en9ZE.default).confluencePageViewPrompt3
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).confluencePageViewPrompt4
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).confluencePageViewPrompt5
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).confluencePageViewPrompt6
        }
    ],
    [(0, $6iWVH.PageContextType).CONFLUENCE_BLOG_VIEW]: [
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).confluencePageViewPrompt1
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).confluencePageViewPrompt2
        },
        {
            labelType: 'rephrase-content',
            message: (0, $en9ZE.default).confluencePageViewPrompt3
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).confluencePageViewPrompt4
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).confluencePageViewPrompt5
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).confluencePageViewPrompt6
        }
    ],
    [(0, $6iWVH.PageContextType).CONFLUENCE_WHITEBOARD]: [
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).confluenceWhiteboardPrompt1
        },
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).confluenceWhiteboardPrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).confluenceWhiteboardPrompt3
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).confluenceWhiteboardPrompt4
        }
    ],
    [(0, $6iWVH.PageContextType).CONFLUENCE_PAGE_EDIT]: [
        {
            labelType: 'rephrase-content',
            message: (0, $en9ZE.default).confluencePageEditPrompt1
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).confluencePageEditPrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).confluencePageEditPrompt3
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).confluencePageEditPrompt4
        }
    ],
    [(0, $6iWVH.PageContextType).CONFLUENCE_BLOG_EDIT]: [
        {
            labelType: 'rephrase-content',
            message: (0, $en9ZE.default).confluencePageEditPrompt1
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).confluencePageEditPrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).confluencePageEditPrompt3
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).confluencePageEditPrompt4
        }
    ],
    [(0, $6iWVH.PageContextType).JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY]: [],
    [(0, $6iWVH.PageContextType).JIRA_CMP_SPACE_SETTINGS_PERMISSIONS_LEGACY]: [],
    [(0, $6iWVH.PageContextType).JIRA_TMP_SPACE_SETTINGS_ACCESS]: [],
    [(0, $6iWVH.PageContextType).JIRA_HOME]: [
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).jiraHomePrompt1
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).jiraHomePrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).jiraHomePrompt3
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).jiraHomePrompt4
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).jiraHomePrompt5
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).jiraHomePrompt6
        }
    ],
    [(0, $6iWVH.PageContextType).JIRA_FOR_YOU]: [
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).unknownPrompt1
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).unknownPrompt2
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).unknownPrompt3
        }
    ],
    [(0, $6iWVH.PageContextType).JIRA_ISSUE_VIEW]: [
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).jiraIssueViewPrompt1
        },
        {
            labelType: 'rephrase-content',
            message: (0, $en9ZE.default).jiraIssueViewPrompt2
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).jiraIssueViewPrompt3
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).jiraIssueViewPrompt4
        }
    ],
    [(0, $6iWVH.PageContextType).JIRA_PROJECT]: [
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).jiraProjectPrompt1
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).jiraProjectPrompt2
        },
        {
            labelType: 'measure-productivity',
            message: (0, $en9ZE.default).jiraProjectPrompt3
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).jiraProjectPrompt4
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).jiraProjectPrompt5
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).jiraProjectPrompt6
        },
        {
            labelType: 'measure-productivity',
            message: (0, $en9ZE.default).jiraProjectPrompt7
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).jiraProjectPrompt8
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).jiraProjectPrompt9
        },
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).jiraProjectPrompt10
        },
        {
            labelType: 'rephrase-content',
            message: (0, $en9ZE.default).jiraProjectPrompt11
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).jiraProjectPrompt12
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).jiraProjectPrompt13
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).jiraProjectPrompt14
        }
    ],
    [(0, $6iWVH.PageContextType).JIRA_BOARD]: [
        {
            labelType: 'automation-rule',
            message: (0, $en9ZE.default).jiraBoardPrompt1
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).jiraBoardPrompt2
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).jiraBoardPrompt3
        },
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).jiraBoardPrompt4
        },
        {
            labelType: 'check-status',
            message: (0, $en9ZE.default).jiraBoardPrompt5
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).jiraBoardPrompt6
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).jiraBoardPrompt7
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).jiraBoardPrompt8
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).jiraBoardPrompt9
        },
        {
            labelType: 'manage-settings',
            message: (0, $en9ZE.default).jiraBoardPrompt10
        }
    ],
    [(0, $6iWVH.PageContextType).JSM_INCIDENT_VIEW]: [
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).jsmIncidentViewPrompt1
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).jsmIncidentViewPrompt2
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).jsmIncidentViewPrompt3
        }
    ],
    [(0, $6iWVH.PageContextType).JSM_INCIDENT_LIST_VIEW]: [
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).jsmIncidentListViewPrompt1
        },
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).jsmIncidentListViewPrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).jsmIncidentListViewPrompt3
        }
    ],
    [(0, $6iWVH.PageContextType).JSM_ALERT_VIEW]: [
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).jsmAlertViewPrompt1
        },
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).jsmAlertViewPrompt2
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).jsmAlertViewPrompt3
        }
    ],
    [(0, $6iWVH.PageContextType).JSM_ALERT_LIST_VIEW]: [
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).jsmAlertListViewPrompt1
        },
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).jsmAlertListViewPrompt2
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).jsmAlertListViewPrompt3
        }
    ],
    [(0, $6iWVH.PageContextType).JSM_ALERT_GROUP_DETAIL_VIEW]: [
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).jsmAlertGroupDetailViewPrompt1
        },
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).jsmAlertGroupDetailViewPrompt2
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).jsmAlertGroupDetailViewPrompt3
        }
    ],
    [(0, $6iWVH.PageContextType).ATLAS_HOME]: [
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).atlasHomePrompt1
        },
        {
            labelType: 'measure-productivity',
            message: (0, $en9ZE.default).atlasHomePrompt2
        },
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).atlasHomePrompt3
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).atlasHomePrompt4
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).atlasHomePrompt5
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).atlasHomePrompt6
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).confluenceHomePrompt1
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).confluenceHomePrompt4
        },
        {
            labelType: 'rephrase-content',
            message: (0, $en9ZE.default).confluenceHomePrompt5
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).confluenceHomePrompt11
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).confluenceHomePrompt8
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).confluenceHomePrompt10
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).jiraHomePrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).jiraHomePrompt3
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).jiraHomePrompt4
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).atlasHomePrompt7
        }
    ],
    [(0, $6iWVH.PageContextType).ATLAS_HOME_MAIN]: [],
    [(0, $6iWVH.PageContextType).ATLAS_HOME_DISCOVER]: [],
    [(0, $6iWVH.PageContextType).ATLAS_HOME_RECENTS]: [],
    [(0, $6iWVH.PageContextType).ATLAS_HOME_FULL_PAGE_NOTIFICATIONS]: [],
    [(0, $6iWVH.PageContextType).ATLAS_HOME_PROJECT_UPDATES_LIST]: [],
    [(0, $6iWVH.PageContextType).ATLAS_HOME_GOAL_UPDATES_LIST]: [],
    [(0, $6iWVH.PageContextType).ATLAS_HOME_TEAM_UPDATES_LIST]: [],
    [(0, $6iWVH.PageContextType).ATLAS_HOME_TAG_UPDATES_LIST]: [],
    [(0, $6iWVH.PageContextType).FOCUS]: [
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).focusPrompt1
        },
        {
            labelType: 'measure-productivity',
            message: (0, $en9ZE.default).focusPrompt2
        }
    ],
    [(0, $6iWVH.PageContextType).FOCUS_FOR_YOU]: [
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).focusForYouPrompt1
        }
    ],
    [(0, $6iWVH.PageContextType).FOCUS_FOCUS_AREA_PAGE]: [
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).focusAreaPrompt1
        }
    ],
    [(0, $6iWVH.PageContextType).FOCUS_FOCUS_AREA_GOAL_VIEW]: [
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).focusAreaGoalPrompt1
        }
    ],
    [(0, $6iWVH.PageContextType).FOCUS_FOCUS_AREA_WORK_VIEW]: [
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).focusAreaWorkPrompt1
        }
    ],
    [(0, $6iWVH.PageContextType).FOCUS_FOCUS_AREA_FUNDS_VIEW]: [
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).focusAreaPrompt1
        },
        {
            labelType: 'analyze-content',
            message: (0, $en9ZE.default).focusAreaFundsPrompt1
        }
    ],
    [(0, $6iWVH.PageContextType).SAC]: [
        {
            labelType: 'manage-settings',
            message: (0, $en9ZE.default).sacPrompt1
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).sacPrompt2
        },
        {
            labelType: 'automation-rule',
            message: (0, $en9ZE.default).sacPrompt3
        }
    ],
    [(0, $6iWVH.PageContextType).TRELLO_BOARD]: [
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).trelloBoardPrompt1
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).trelloBoardPrompt2
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).trelloBoardPrompt3
        }
    ],
    [(0, $6iWVH.PageContextType).TRELLO_CARD]: [
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).trelloCardPrompt1
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).trelloCardPrompt2
        },
        {
            labelType: 'rephrase-content',
            message: (0, $en9ZE.default).trelloCardPrompt3
        }
    ],
    [(0, $6iWVH.PageContextType).UNKNOWN]: [
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).unknownPrompt1
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).unknownPrompt2
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).unknownPrompt3
        }
    ],
    [(0, $6iWVH.PageContextType).STUDIO_AGENT_BUILDER]: [
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).studioAgentBuilderPrompt1
        },
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).studioAgentBuilderPrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).studioAgentBuilderPrompt3
        }
    ],
    [(0, $6iWVH.PageContextType).ADMIN_HUB]: []
};
const $ae28fc22beba689b$export$a905239756c1fbae = (location)=>{
    const jsmIncidentViewPatterns = [
        // Single incident view (with issue key at the end)
        [
            (0, $6iWVH.PageContextType).JSM_INCIDENT_VIEW,
            /\/jira\/servicedesk\/projects\/[^\/]+\/section\/incidents\/custom\/\d+\/[A-Z]+-\d+/
        ]
    ];
    const jsmOpsPatterns = (0, $iDrrr.fg)('rovo_ops_conversation_starters_enabled') ? [
        // Incident list view (without issue key at the end)
        [
            (0, $6iWVH.PageContextType).JSM_INCIDENT_LIST_VIEW,
            /\/jira\/servicedesk\/projects\/[^\/]+\/section\/incidents\/custom\/\d+$/
        ],
        // Single alert view (has / after alerts)
        [
            (0, $6iWVH.PageContextType).JSM_ALERT_VIEW,
            /\/jira\/ops\/alerts\//
        ],
        // Alert list view (has ? after alerts)
        [
            (0, $6iWVH.PageContextType).JSM_ALERT_LIST_VIEW,
            /\/jira\/ops\/alerts\?/
        ],
        // Alert group detail view
        [
            (0, $6iWVH.PageContextType).JSM_ALERT_GROUP_DETAIL_VIEW,
            /\/jira\/ops\/group-detail\//
        ]
    ] : [];
    const jiraBoardPattern = /\/jira\/.+\/projects\/[^\/]+\/boards\/[^\/?]+/;
    // Jira board contextual starters are gated by a targeting feature gate plus an experiment.
    // Unlike most patterns below, we test the board route before adding it to urlPatterns so
    // getExperimentValue is only read on board pages and non-board pages do not log exposures.
    const jiraBoardPatterns = [];
    if (jiraBoardPattern.test(location) && (0, $iDrrr.fg)('jira_boards_rovo_contextual_actions_experiment_eligibility')) {
        const actionsVariant = (0, $cXtTj.default).getExperimentValue('jira_boards_rovo_actions_exp_targeted', 'actions_variant', 'control_static_actions');
        if (actionsVariant === 'contextual_actions_only') jiraBoardPatterns.push([
            (0, $6iWVH.PageContextType).JIRA_BOARD,
            jiraBoardPattern
        ]);
    }
    // Builder starters show only on a Studio agent page reached via "Customize a template", marked by
    // the `fromTemplate=true` param Studio stamps on the URL. Scoped to the `studio.` domain so it
    // never matches other products, and tested before `fg` so exposure stays on these pages.
    const studioAgentBuilderFromTemplatePattern = /\/\/studio\.[^/]+\/.*\/agents\/[^#]*[?&]fromTemplate=true(?:&|#|$)/;
    const studioAgentBuilderPatterns = studioAgentBuilderFromTemplatePattern.test(location) && (0, $iDrrr.fg)('sgrow-149-open-rovo-after-customize') ? [
        [
            (0, $6iWVH.PageContextType).STUDIO_AGENT_BUILDER,
            studioAgentBuilderFromTemplatePattern
        ]
    ] : [];
    const urlPatterns = [
        ...studioAgentBuilderPatterns,
        [
            (0, $6iWVH.PageContextType).BITBUCKET_REPOSITORY_SOURCE,
            /bitbucket\.org\/[^\/]+\/[^\/]+\/src\//
        ],
        [
            (0, $6iWVH.PageContextType).BITBUCKET_PULL_REQUEST,
            /bitbucket\.org\/[^\/]+\/[^\/]+\/pull-requests\/\d+/
        ],
        [
            (0, $6iWVH.PageContextType).BITBUCKET_CREATE_PULL_REQUEST,
            /bitbucket\.org\/[^\/]+\/[^\/]+\/pull-requests\/new/
        ],
        [
            (0, $6iWVH.PageContextType).BITBUCKET_PIPELINES,
            /bitbucket\.org\/[^\/]+\/[^\/]+\/pipelines\/results\/[^\/]+\/steps\//
        ],
        [
            (0, $6iWVH.PageContextType).BITBUCKET,
            /bitbucket\.org\/.*/
        ],
        [
            (0, $6iWVH.PageContextType).CONFLUENCE_HOME,
            /\/wiki\/?$/
        ],
        [
            (0, $6iWVH.PageContextType).CONFLUENCE_HOME,
            /\/wiki\/home$/
        ],
        [
            (0, $6iWVH.PageContextType).CONFLUENCE_BLOG_EDIT,
            /\/wiki\/spaces\/[^\/]+\/blog\/edit-v2\//
        ],
        [
            (0, $6iWVH.PageContextType).CONFLUENCE_BLOG_VIEW,
            /\/wiki\/spaces\/[^\/]+\/blog\//
        ],
        [
            (0, $6iWVH.PageContextType).CONFLUENCE_PAGE_EDIT,
            /\/wiki\/spaces\/[^\/]+\/pages\/edit-v2\//
        ],
        [
            (0, $6iWVH.PageContextType).CONFLUENCE_PAGE_VIEW,
            /\/wiki\/spaces\/[^\/]+\/pages\//
        ],
        [
            (0, $6iWVH.PageContextType).CONFLUENCE_WHITEBOARD,
            /\/wiki\/spaces\/[^\/]+\/whiteboard\//
        ],
        [
            (0, $6iWVH.PageContextType).JIRA_ISSUE_VIEW,
            /\/browse\/[^\/]+$/
        ],
        [
            (0, $6iWVH.PageContextType).JIRA_ISSUE_VIEW,
            /\/jira\/.+\/projects\/[^/]+\/[^?]+\?(?:.*&)?selectedIssue=/
        ],
        ...jsmIncidentViewPatterns,
        ...jsmOpsPatterns,
        [
            (0, $6iWVH.PageContextType).JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY,
            /\/plugins\/servlet\/project-config\/[^\/]+\/people/
        ],
        [
            (0, $6iWVH.PageContextType).JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY,
            /\/plugins\/servlet\/project-config\/[^\/]+\/permissions/
        ],
        [
            (0, $6iWVH.PageContextType).JIRA_TMP_SPACE_SETTINGS_ACCESS,
            /\/jira\/software\/projects\/[^\/]+\/settings\/access/
        ],
        ...jiraBoardPatterns,
        [
            (0, $6iWVH.PageContextType).JIRA_PROJECT,
            /\/jira\/.+\/projects\//
        ],
        [
            (0, $6iWVH.PageContextType).JIRA_HOME,
            /\/jira\/dashboards\/last-visited$/
        ],
        [
            (0, $6iWVH.PageContextType).JIRA_FOR_YOU,
            /\/jira\/for-you$/
        ],
        // atlas home is either home.atlassian.com, home.stg.atlassian.com, team.atlassian.com, or team.stg.atlassian.com
        [
            (0, $6iWVH.PageContextType).ATLAS_HOME_DISCOVER,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*discover+/
        ],
        [
            (0, $6iWVH.PageContextType).ATLAS_HOME_RECENTS,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*recents+/
        ],
        [
            (0, $6iWVH.PageContextType).ATLAS_HOME_FULL_PAGE_NOTIFICATIONS,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*notifications+/
        ],
        [
            (0, $6iWVH.PageContextType).ATLAS_HOME_PROJECT_UPDATES_LIST,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*updates\/projects+/
        ],
        [
            (0, $6iWVH.PageContextType).ATLAS_HOME_GOAL_UPDATES_LIST,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*updates\/goals+/
        ],
        [
            (0, $6iWVH.PageContextType).ATLAS_HOME_TEAM_UPDATES_LIST,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*updates\/team+/
        ],
        [
            (0, $6iWVH.PageContextType).ATLAS_HOME_TAG_UPDATES_LIST,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*updates\/tag+/
        ],
        [
            (0, $6iWVH.PageContextType).ATLAS_HOME_MAIN,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*\?cloudId=[^\/]+/
        ],
        [
            (0, $6iWVH.PageContextType).ATLAS_HOME,
            /\/(home|team)\./
        ],
        [
            (0, $6iWVH.PageContextType).FOCUS_FOCUS_AREA_GOAL_VIEW,
            /\/focus\/focus-area\/.*\/goals/
        ],
        [
            (0, $6iWVH.PageContextType).FOCUS_FOCUS_AREA_WORK_VIEW,
            /\/focus\/focus-area\/.*\/work/
        ],
        ...(0, $iDrrr.fg)('rovo_chat_focus_analyze_funds') ? [
            [
                (0, $6iWVH.PageContextType).FOCUS_FOCUS_AREA_FUNDS_VIEW,
                /\/focus\/focus-area\/.*\/funds/
            ]
        ] : [],
        [
            (0, $6iWVH.PageContextType).FOCUS_FOCUS_AREA_PAGE,
            /\/focus\/focus-area\/.*/
        ],
        [
            (0, $6iWVH.PageContextType).FOCUS_FOR_YOU,
            /\/focus\/for-you(?:\/.*)?$/
        ],
        [
            (0, $6iWVH.PageContextType).FOCUS,
            /\/focus\/.*/
        ],
        [
            (0, $6iWVH.PageContextType).SAC,
            /support\.atlassian\.com/
        ],
        // Trello: card view first (more specific), then board. Prod: trello.com, Staging: trellis.coffee (and *.atlassian.com)
        [
            (0, $6iWVH.PageContextType).TRELLO_CARD,
            /(?:trello\.com|trellis\.coffee|[\w-]*trello[\w-]*\.(?:stg\.)?atlassian\.com)\/c\//
        ],
        [
            (0, $6iWVH.PageContextType).TRELLO_BOARD,
            /(?:trello\.com|trellis\.coffee|[\w-]*trello[\w-]*\.(?:stg\.)?atlassian\.com)\/b\//
        ],
        // admin hub: admin.atlassian.com (production) or admin.stg.atlassian.com (staging)
        [
            (0, $6iWVH.PageContextType).ADMIN_HUB,
            /admin(\.stg)?\.atlassian\.com/
        ]
    ];
    for (const [type, pattern] of urlPatterns){
        const matched = pattern.test(location);
        if (!matched) continue;
        return type;
    }
    return (0, $6iWVH.PageContextType).UNKNOWN;
};
const $ae28fc22beba689b$export$bc4bf2ff8e40b690 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const location = (0, $lFQjm.useWindowLocation)();
    let t0;
    if ($[0] !== location) {
        t0 = $ae28fc22beba689b$export$a905239756c1fbae(location);
        $[0] = location;
        $[1] = t0;
    } else t0 = $[1];
    const [pageContextType, setPageContextType] = (0, $cozmU.useState)(t0);
    let t1;
    let t2;
    if ($[2] !== location) {
        t1 = ()=>{
            setPageContextType($ae28fc22beba689b$export$a905239756c1fbae(location));
        };
        t2 = [
            location
        ];
        $[2] = location;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return pageContextType;
} : ()=>{
    const location = (0, $lFQjm.useWindowLocation)();
    const [pageContextType, setPageContextType] = (0, $cozmU.useState)($ae28fc22beba689b$export$a905239756c1fbae(location));
    (0, $cozmU.useEffect)(()=>{
        setPageContextType($ae28fc22beba689b$export$a905239756c1fbae(location));
    }, [
        location
    ]);
    return pageContextType;
};
const $ae28fc22beba689b$var$shuffleStarters = (arr)=>{
    const copiedArr = [
        ...arr
    ];
    // Shuffle array using Fisher-Yates algorithm
    for(let i = arr.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        [copiedArr[i], copiedArr[j]] = [
            copiedArr[j],
            copiedArr[i]
        ];
    }
    return copiedArr;
};
const $ae28fc22beba689b$export$82bea1a28fda43c1 = (starters, num)=>{
    // Return the first `num` items
    return $ae28fc22beba689b$var$shuffleStarters(starters).slice(0, num);
};
const $ae28fc22beba689b$var$getIconAndLabelForStarter = (labelType)=>{
    switch(labelType){
        case 'be-productive':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1TvTa))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).beProductiveLabel
            };
        case 'stay-up-to-date':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1TvTa))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).stayUpToDateLabel
            };
        case 'summarize-content':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aooxV))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).summarizeContentLabel
            };
        case 'rephrase-content':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aooxV))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).rephraseContentLabel
            };
        case 'draft-content':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aooxV))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).draftContentLabel
            };
        case 'find-information':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).findInformationLabel
            };
        case 'find-people':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).findPeopleLabel
            };
        case 'code-search':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).codeSearchLabel
            };
        case 'measure-productivity':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1TvTa))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).measureProductivityLabel
            };
        case 'get-answers':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).getAnswersLabel
            };
        case 'check-status':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5n93X))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).checkStatusLabel
            };
        case 'summarize-information':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).summarizeInformationLabel
            };
        case 'analyze-content':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).analyzeContentLabel
            };
        case 'summarize-code':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jXXTm))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).summarizeCodeLabel
            };
        case 'manage-settings':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($4s4Os))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).manageSettingsLabel
            };
        case 'automation-rule':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($11OF7))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).automationRuleLabel
            };
        default:
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1TvTa))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).beProductiveLabel
            };
    }
};
// default to fetching 3 dynamic starters
const $ae28fc22beba689b$var$DYNAMIC_STARTERS_COUNT = 3;
const $ae28fc22beba689b$export$65b45f3b39cd6930 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(38);
    const { numStarters: numStarters, dynamicStartersConfig: dynamicStartersConfig, assistanceServiceParams: assistanceServiceParams } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const pageContextType = $ae28fc22beba689b$export$bc4bf2ff8e40b690();
    const location = (0, $lFQjm.useWindowLocation)();
    const t1 = dynamicStartersConfig?.enabled && !!assistanceServiceParams;
    let t2;
    if ($[0] !== assistanceServiceParams) {
        t2 = assistanceServiceParams || {
            touchpointSource: "",
            product: "",
            experienceId: "",
            siteId: ""
        };
        $[0] = assistanceServiceParams;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== location || $[3] !== pageContextType || $[4] !== t1 || $[5] !== t2) {
        t3 = {
            contentUrl: location,
            pageContextType: pageContextType,
            showConvoStarters: t1,
            assistanceServiceParams: t2
        };
        $[2] = location;
        $[3] = pageContextType;
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    const { convoStarters: dynamicStarterActions, isLoading: isDynamicStarterActionsLoading } = (0, $7HZZ5.useFetchConvoStarters)(t3);
    const t4 = $ae28fc22beba689b$export$c6a4ebf596b0c08a[pageContextType];
    let t5;
    if ($[7] !== formatMessage || $[8] !== t4) {
        let t6;
        if ($[10] !== formatMessage) {
            t6 = (starter)=>{
                const shouldShowBetaBadge = starter.message === (0, $en9ZE.default).focusAreaFundsPrompt1;
                return {
                    labelType: starter.labelType,
                    message: formatMessage(starter.message),
                    badge: shouldShowBetaBadge ? /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), {
                        appearance: "discovery"
                    }, formatMessage((0, $en9ZE.default).focusAreaFundsBetaBadge)) : undefined,
                    type: "static"
                };
            };
            $[10] = formatMessage;
            $[11] = t6;
        } else t6 = $[11];
        t5 = t4.map(t6);
        $[7] = formatMessage;
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    const contextualStarters = t5;
    const staticStarters = contextualStarters;
    let t6;
    if ($[12] !== staticStarters) {
        t6 = staticStarters.reduce($ae28fc22beba689b$var$_temp, {});
        $[12] = staticStarters;
        $[13] = t6;
    } else t6 = $[13];
    const groupedStarters = t6;
    let t7;
    if ($[14] !== groupedStarters) {
        t7 = Object.entries(groupedStarters).map($ae28fc22beba689b$var$_temp6);
        $[14] = groupedStarters;
        $[15] = t7;
    } else t7 = $[15];
    const conversationStarterActions = t7;
    let t8;
    if ($[16] !== formatMessage || $[17] !== groupedStarters) {
        t8 = Object.entries(groupedStarters).map((t9)=>{
            const [, starters_0] = t9;
            const { icon: icon, label: label } = $ae28fc22beba689b$var$getIconAndLabelForStarter(starters_0[0].labelType);
            return {
                id: "convo-starter",
                title: formatMessage(label),
                icon: ()=>icon,
                onClick: $ae28fc22beba689b$var$_temp7,
                badge: starters_0.find($ae28fc22beba689b$var$_temp8)?.badge,
                children: starters_0.map((starter_3)=>{
                    const starterHasPlaceholder_0 = starter_3.message.includes("`");
                    return {
                        id: "convo-starter",
                        title: starter_3.message,
                        icon: ()=>icon,
                        onClick: $ae28fc22beba689b$var$_temp9,
                        type: "convo-starter-action",
                        handleType: (0, $6iWVH.HandleActionType).Chat,
                        ...starterHasPlaceholder_0 ? {
                            dynamicPrompt: starter_3.message
                        } : {
                            staticPrompt: starter_3.message
                        },
                        badge: starter_3.badge,
                        starterType: "static"
                    };
                }),
                handleType: (0, $6iWVH.HandleActionType).Nested,
                type: "convo-starter-action"
            };
        });
        $[16] = formatMessage;
        $[17] = groupedStarters;
        $[18] = t8;
    } else t8 = $[18];
    const nestedConversationStarterActions = t8;
    const numStartersToReturn = numStarters ?? conversationStarterActions.length + dynamicStarterActions.length;
    const numNestedStartersToReturn = numStarters ?? nestedConversationStarterActions.length;
    dynamicStartersConfig?.enabled;
    let t9;
    bb0: {
        if (!dynamicStartersConfig?.enabled) {
            let t10;
            if ($[19] !== conversationStarterActions || $[20] !== numStartersToReturn) {
                t10 = $ae28fc22beba689b$export$82bea1a28fda43c1(conversationStarterActions, numStartersToReturn);
                $[19] = conversationStarterActions;
                $[20] = numStartersToReturn;
                $[21] = t10;
            } else t10 = $[21];
            t9 = t10;
            break bb0;
        }
        if (isDynamicStarterActionsLoading) {
            let t10;
            if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
                t10 = [];
                $[22] = t10;
            } else t10 = $[22];
            t9 = t10;
            break bb0;
        }
        if (dynamicStarterActions.length >= numStartersToReturn) {
            let t10;
            if ($[23] !== dynamicStarterActions || $[24] !== numStartersToReturn) {
                t10 = dynamicStarterActions.slice(0, numStartersToReturn);
                $[23] = dynamicStarterActions;
                $[24] = numStartersToReturn;
                $[25] = t10;
            } else t10 = $[25];
            t9 = t10;
            break bb0;
        }
        let t10;
        if ($[26] !== conversationStarterActions || $[27] !== dynamicStarterActions || $[28] !== numStartersToReturn) {
            t10 = [
                ...dynamicStarterActions,
                ...$ae28fc22beba689b$export$82bea1a28fda43c1(conversationStarterActions, numStartersToReturn - dynamicStarterActions.length)
            ];
            $[26] = conversationStarterActions;
            $[27] = dynamicStarterActions;
            $[28] = numStartersToReturn;
            $[29] = t10;
        } else t10 = $[29];
        t9 = t10;
    }
    const randomizedConversationStarterActions = t9;
    let t10;
    if ($[30] !== nestedConversationStarterActions || $[31] !== numNestedStartersToReturn) {
        t10 = $ae28fc22beba689b$export$82bea1a28fda43c1(nestedConversationStarterActions, numNestedStartersToReturn);
        $[30] = nestedConversationStarterActions;
        $[31] = numNestedStartersToReturn;
        $[32] = t10;
    } else t10 = $[32];
    const randomizedNestedConversationStarterActions = t10;
    const t11 = Math.min($ae28fc22beba689b$var$DYNAMIC_STARTERS_COUNT, numStartersToReturn);
    let t12;
    if ($[33] !== isDynamicStarterActionsLoading || $[34] !== randomizedConversationStarterActions || $[35] !== randomizedNestedConversationStarterActions || $[36] !== t11) {
        t12 = {
            conversationStarterActions: randomizedConversationStarterActions,
            nestedConversationStarterActions: randomizedNestedConversationStarterActions,
            getRandomStarters: $ae28fc22beba689b$export$82bea1a28fda43c1,
            isDynamicStarterActionsLoading: isDynamicStarterActionsLoading,
            numDynamicStarterActionsLoading: t11
        };
        $[33] = isDynamicStarterActionsLoading;
        $[34] = randomizedConversationStarterActions;
        $[35] = randomizedNestedConversationStarterActions;
        $[36] = t11;
        $[37] = t12;
    } else t12 = $[37];
    return t12;
} : ({ numStarters: numStarters, dynamicStartersConfig: dynamicStartersConfig, assistanceServiceParams: assistanceServiceParams })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const pageContextType = $ae28fc22beba689b$export$bc4bf2ff8e40b690();
    const location = (0, $lFQjm.useWindowLocation)();
    const { convoStarters: dynamicStarterActions, isLoading: isDynamicStarterActionsLoading } = (0, $7HZZ5.useFetchConvoStarters)({
        contentUrl: location,
        pageContextType: pageContextType,
        showConvoStarters: dynamicStartersConfig?.enabled && !!assistanceServiceParams,
        // hacky workaround for consumers that don't need dynamic starters (and therfore don't pass in assistanceServiceParams)
        assistanceServiceParams: assistanceServiceParams || {
            touchpointSource: '',
            product: '',
            experienceId: '',
            siteId: ''
        }
    });
    const staticStarters = (0, $cozmU.useMemo)(()=>{
        const contextualStarters = $ae28fc22beba689b$export$c6a4ebf596b0c08a[pageContextType].map((starter)=>{
            const shouldShowBetaBadge = starter.message === (0, $en9ZE.default).focusAreaFundsPrompt1;
            return {
                labelType: starter.labelType,
                message: formatMessage(starter.message),
                badge: shouldShowBetaBadge ? /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), {
                    appearance: "discovery"
                }, formatMessage((0, $en9ZE.default).focusAreaFundsBetaBadge)) : undefined,
                type: 'static'
            };
        });
        return contextualStarters;
    }, [
        pageContextType,
        formatMessage
    ]);
    const groupedStarters = (0, $cozmU.useMemo)(()=>staticStarters.reduce((acc, starter_0)=>{
            if (!starter_0.labelType) return acc;
            acc[starter_0.labelType] = [
                ...acc[starter_0.labelType] || [],
                starter_0
            ];
            return acc;
        }, {}), [
        staticStarters
    ]);
    // Use this to get conversation starter actions that are not nested (e.g. for Sidebar)
    const conversationStarterActions = (0, $cozmU.useMemo)(()=>Object.entries(groupedStarters).map(([, starters])=>{
            // If there is only one starter in the group, return as a single chat action, otherwise return one of the nested items to use as a starter
            if (starters.length === 1) {
                const starter_1 = starters[0];
                const starterHasPlaceholder = starter_1.message.includes('`');
                return {
                    id: 'convo-starter',
                    title: starter_1.message,
                    icon: ()=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
                            label: ""
                        }),
                    onClick: ()=>{},
                    handleType: (0, $6iWVH.HandleActionType).Chat,
                    children: [],
                    ...starterHasPlaceholder ? {
                        dynamicPrompt: starter_1.message
                    } : {
                        staticPrompt: starter_1.message
                    },
                    badge: starter_1.badge,
                    type: 'convo-starter-action',
                    starterType: 'static'
                };
            } else {
                //Grab a random starter from the group to use
                const randomIndex = Math.floor(Math.random() * starters.length);
                const randomStarter = starters[randomIndex];
                const randomStarterHasPlaceholder = randomStarter.message.includes('`');
                return {
                    id: `convo-starter`,
                    title: randomStarter.message,
                    icon: ()=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
                            label: ""
                        }),
                    onClick: ()=>{},
                    handleType: (0, $6iWVH.HandleActionType).Chat,
                    ...randomStarterHasPlaceholder ? {
                        dynamicPrompt: randomStarter.message
                    } : {
                        staticPrompt: randomStarter.message
                    },
                    badge: randomStarter.badge,
                    type: 'convo-starter-action',
                    starterType: 'static'
                };
            }
        }), [
        groupedStarters
    ]);
    // Use this to get conversation starter actions that are nested (e.g. for Full Screen)
    const nestedConversationStarterActions = (0, $cozmU.useMemo)(()=>Object.entries(groupedStarters).map(([, starters_0])=>{
            const { icon: icon, label: label } = $ae28fc22beba689b$var$getIconAndLabelForStarter(starters_0[0].labelType);
            return {
                id: 'convo-starter',
                title: formatMessage(label),
                icon: ()=>icon,
                onClick: ()=>{},
                badge: starters_0.find((starter_2)=>starter_2.badge)?.badge,
                children: starters_0.map((starter_3)=>{
                    const starterHasPlaceholder_0 = starter_3.message.includes('`');
                    return {
                        id: 'convo-starter',
                        title: starter_3.message,
                        icon: ()=>icon,
                        onClick: ()=>{},
                        type: 'convo-starter-action',
                        handleType: (0, $6iWVH.HandleActionType).Chat,
                        ...starterHasPlaceholder_0 ? {
                            dynamicPrompt: starter_3.message
                        } : {
                            staticPrompt: starter_3.message
                        },
                        badge: starter_3.badge,
                        starterType: 'static'
                    };
                }),
                handleType: (0, $6iWVH.HandleActionType).Nested,
                type: 'convo-starter-action'
            };
        }), [
        groupedStarters,
        formatMessage
    ]);
    const numStartersToReturn = numStarters ?? conversationStarterActions.length + dynamicStarterActions.length;
    // dynamic starter actions are not included in nested use case
    const numNestedStartersToReturn = numStarters ?? nestedConversationStarterActions.length;
    const randomizedConversationStarterActions = (0, $cozmU.useMemo)(()=>{
        if (!dynamicStartersConfig?.enabled) return $ae28fc22beba689b$export$82bea1a28fda43c1(conversationStarterActions, numStartersToReturn);
        if (isDynamicStarterActionsLoading) return [];
        if (dynamicStarterActions.length >= numStartersToReturn) return dynamicStarterActions.slice(0, numStartersToReturn);
        // prioritizes dynamic starters, and then randomizes the static starters
        return [
            ...dynamicStarterActions,
            ...$ae28fc22beba689b$export$82bea1a28fda43c1(conversationStarterActions, numStartersToReturn - dynamicStarterActions.length)
        ];
    }, [
        conversationStarterActions,
        numStartersToReturn,
        dynamicStarterActions,
        isDynamicStarterActionsLoading,
        dynamicStartersConfig?.enabled
    ]);
    const randomizedNestedConversationStarterActions = (0, $cozmU.useMemo)(()=>{
        return $ae28fc22beba689b$export$82bea1a28fda43c1(nestedConversationStarterActions, numNestedStartersToReturn);
    }, [
        nestedConversationStarterActions,
        numNestedStartersToReturn
    ]);
    return {
        conversationStarterActions: randomizedConversationStarterActions,
        nestedConversationStarterActions: randomizedNestedConversationStarterActions,
        getRandomStarters: $ae28fc22beba689b$export$82bea1a28fda43c1,
        isDynamicStarterActionsLoading: isDynamicStarterActionsLoading,
        numDynamicStarterActionsLoading: Math.min($ae28fc22beba689b$var$DYNAMIC_STARTERS_COUNT, numStartersToReturn)
    };
};
function $ae28fc22beba689b$var$_temp(acc, starter_0) {
    if (!starter_0.labelType) return acc;
    acc[starter_0.labelType] = [
        ...acc[starter_0.labelType] || [],
        starter_0
    ];
    return acc;
}
function $ae28fc22beba689b$var$_temp2() {
    return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
        label: ""
    });
}
function $ae28fc22beba689b$var$_temp3() {}
function $ae28fc22beba689b$var$_temp4() {
    return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
        label: ""
    });
}
function $ae28fc22beba689b$var$_temp5() {}
function $ae28fc22beba689b$var$_temp6(t0) {
    const [, starters] = t0;
    if (starters.length === 1) {
        const starter_1 = starters[0];
        const starterHasPlaceholder = starter_1.message.includes("`");
        return {
            id: "convo-starter",
            title: starter_1.message,
            icon: $ae28fc22beba689b$var$_temp2,
            onClick: $ae28fc22beba689b$var$_temp3,
            handleType: (0, $6iWVH.HandleActionType).Chat,
            children: [],
            ...starterHasPlaceholder ? {
                dynamicPrompt: starter_1.message
            } : {
                staticPrompt: starter_1.message
            },
            badge: starter_1.badge,
            type: "convo-starter-action",
            starterType: "static"
        };
    } else {
        const randomIndex = Math.floor(Math.random() * starters.length);
        const randomStarter = starters[randomIndex];
        const randomStarterHasPlaceholder = randomStarter.message.includes("`");
        return {
            id: "convo-starter",
            title: randomStarter.message,
            icon: $ae28fc22beba689b$var$_temp4,
            onClick: $ae28fc22beba689b$var$_temp5,
            handleType: (0, $6iWVH.HandleActionType).Chat,
            ...randomStarterHasPlaceholder ? {
                dynamicPrompt: randomStarter.message
            } : {
                staticPrompt: randomStarter.message
            },
            badge: randomStarter.badge,
            type: "convo-starter-action",
            starterType: "static"
        };
    }
}
function $ae28fc22beba689b$var$_temp7() {}
function $ae28fc22beba689b$var$_temp8(starter_2) {
    return starter_2.badge;
}
function $ae28fc22beba689b$var$_temp9() {}
module.exports["usePageContextType"] = $ae28fc22beba689b$export$bc4bf2ff8e40b690;
module.exports["useRovoConversationStarters"] = $ae28fc22beba689b$export$65b45f3b39cd6930;

});

parcelRegister("7HZZ5", function(module, exports) {
// adapted from: platform/packages/insights-ai-platform/ai-smart-button/src/ui/ai-actions/hooks/useFetchConvoStarters.ts

var $cozmU = parcelRequire("cozmU");


var $mfdwv = parcelRequire("mfdwv");


var $irnO2 = parcelRequire("irnO2");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $5SS4O = parcelRequire("5SS4O");


var $lJ6db = parcelRequire("lJ6db");


var $6iWVH = parcelRequire("6iWVH");


var $5uiWK = parcelRequire("5uiWK");


var $bQmvI = parcelRequire("bQmvI");

const $534dbfa9546a4c22$var$mapToConversationActionNew = (starterObject)=>{
    return {
        id: 'convo-starter',
        title: starterObject.starter,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
                label: ""
            }),
        staticPrompt: starterObject.starter,
        handleType: (0, $6iWVH.HandleActionType).Chat,
        starterType: 'dynamic',
        jtbdCategory: starterObject.jtbd_category,
        agent: undefined,
        type: 'convo-starter-action'
    };
};
const $534dbfa9546a4c22$export$460b2fd9dae847fd = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker, siteId: siteId }, contentUrl: contentUrl, pageContextType: pageContextType, showConvoStarters: showConvoStarters = false })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const timingRef = (0, $cozmU.useRef)(null);
    const contentAri = (0, $cozmU.useMemo)(()=>(0, $bQmvI.getContentAri)(siteId, contentUrl, pageContextType), [
        siteId,
        contentUrl,
        pageContextType
    ]);
    // TODO ASIMO-2398: experiment cleanup
    const urlDebugInfo = (0, $cozmU.useMemo)(()=>{
        try {
            const url = new URL(contentUrl);
            return {
                pathSegmentCount: url.pathname.split('/').filter(Boolean).length,
                hasQueryParams: url.search.length > 0,
                protocol: url.protocol
            };
        } catch  {
            return {
                pathSegmentCount: 0,
                hasQueryParams: false,
                protocol: 'invalid'
            };
        }
    }, [
        contentUrl
    ]);
    const isPageContextTypeSupported = (0, $5uiWK.isPageContextTypeSupportedForDynamicStarters)(pageContextType);
    const isEligibleContext = isPageContextTypeSupported && contentAri !== null;
    const isFeatureEnabled = showConvoStarters && isEligibleContext;
    // TODO ASIMO-2398: experiment cleanup
    (0, $cozmU.useEffect)(()=>{
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'called',
            actionSubject: 'useFetchConvoStarters',
            attributes: {
                showConvoStarters: showConvoStarters,
                isPageContextTypeSupported: isPageContextTypeSupported,
                isEligibleContext: isEligibleContext,
                isFeatureEnabled: isFeatureEnabled,
                pageContextType: String(pageContextType),
                hasContentAri: contentAri !== null,
                contentAri: contentAri,
                urlStructure: urlDebugInfo
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { data: convoStarters, isFetching: isLoading, error: fetchError } = (0, $5SS4O.useQuery)({
        enabled: isFeatureEnabled,
        queryKey: [
            'dynamicConvoStarters',
            contentAri ?? contentUrl
        ],
        queryFn: async ()=>{
            // Custom performance tracking for dynamic starters experiment to analyze on Statsig.
            // Confluence ui taskSuccess events aren't sent to Statsig.
            timingRef.current = {
                startTime: performance.now(),
                sent: false,
                pageContextType: String(pageContextType)
            };
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).FETCH_DYNAMIC_CONVERSATION_STARTERS,
                name: (0, $irnO2.ExperienceName).FETCH_DYNAMIC_CONVERSATION_STARTERS
            });
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'started',
                actionSubject: 'fetchConvoStarters',
                attributes: {
                    pageContextType: timingRef.current.pageContextType
                }
            });
            const response = await assistanceService.getDynamicConvoStartersNew({
                ai_feature_input: {
                    // safe to assert: query is disabled (enabled condition) when contentAri is null
                    documents: [
                        {
                            ari: contentAri
                        }
                    ]
                }
            });
            // Since we only request one document, we should get exactly one result
            const result = response?.ai_feature_output?.results?.[0];
            if (!result) throw new Error('Expected one result in API response but received none');
            if (result.error) {
                const errorType = result.error.error_type;
                // expected failures (HYDRATION_ERROR) are silently filtered
                if (errorType === 'HYDRATION_ERROR') return [];
                throw new Error(`[${errorType}] ${result.error.message}`);
            }
            if (!result.convo_starters.length) return [];
            return result.convo_starters.map((starter)=>$534dbfa9546a4c22$var$mapToConversationActionNew(starter));
        },
        onSuccess: (data)=>{
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).FETCH_DYNAMIC_CONVERSATION_STARTERS
            });
            if (timingRef.current && !timingRef.current.sent) {
                sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'succeeded',
                    actionSubject: 'fetchConvoStarters',
                    attributes: {
                        duration: performance.now() - timingRef.current.startTime,
                        startersCount: data?.length ?? 0,
                        pageContextType: timingRef.current.pageContextType
                    }
                });
                timingRef.current.sent = true;
            }
        },
        onError: (error)=>{
            if (timingRef.current && !timingRef.current.sent) {
                sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'failed',
                    actionSubject: 'fetchConvoStarters',
                    attributes: {
                        duration: performance.now() - timingRef.current.startTime,
                        errorMessage: error.message,
                        pageContextType: timingRef.current.pageContextType
                    }
                });
                timingRef.current.sent = true;
            }
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).FETCH_DYNAMIC_CONVERSATION_STARTERS,
                error: error
            });
        }
    });
    // Track cancellations when component unmounts during fetch
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (timingRef.current && !timingRef.current.sent) {
                sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'cancelled',
                    actionSubject: 'fetchConvoStarters',
                    attributes: {
                        duration: performance.now() - timingRef.current.startTime,
                        pageContextType: timingRef.current.pageContextType
                    }
                });
                timingRef.current.sent = true;
            }
        };
    }, [
        sendAnalyticsEvent
    ]);
    return (0, $cozmU.useMemo)(()=>({
            convoStarters: convoStarters ?? [],
            isLoading: isLoading,
            error: fetchError ?? undefined
        }), [
        convoStarters,
        isLoading,
        fetchError
    ]);
});
module.exports["useFetchConvoStarters"] = $534dbfa9546a4c22$export$460b2fd9dae847fd;

});

parcelRegister("en9ZE", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $b0ccb00ee4479897$var$_default_1 = (0, $kSwu1.defineMessages)({
    // Conversation starter labels
    beProductiveLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.be-productive",
        defaultMessage: "Be productive"
    },
    stayUpToDateLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.stay-up-to-date",
        defaultMessage: "Stay up-to-date"
    },
    summarizeContentLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.summarize-content",
        defaultMessage: "Summarize content"
    },
    rephraseContentLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.rephrase-content",
        defaultMessage: "Rephrase content"
    },
    draftContentLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.draft-content",
        defaultMessage: "Draft content"
    },
    findInformationLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.find-information",
        defaultMessage: "Find information"
    },
    findPeopleLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.find-people",
        defaultMessage: "Find people"
    },
    codeSearchLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.code-search",
        defaultMessage: "Code search"
    },
    measureProductivityLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.measure-productivity",
        defaultMessage: "Measure productivity"
    },
    getAnswersLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.get-answers",
        defaultMessage: "Get answers"
    },
    checkStatusLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.check-status",
        defaultMessage: "Check status"
    },
    summarizeInformationLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.summarize-information",
        defaultMessage: "Summarize information"
    },
    analyzeContentLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.analyze-content",
        defaultMessage: "Analyze content"
    },
    summarizeCodeLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.summarize-code",
        defaultMessage: "Summarize code"
    },
    automationRuleLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.automation-rule",
        defaultMessage: "Automation rule"
    },
    manageSettingsLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.manage-settings",
        defaultMessage: "Manage settings"
    },
    // BITBUCKET_CREATE_PULL_REQUESTS
    bitbucketCreatePullRequestsPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-create-pull-requests.starter-1",
        defaultMessage: "Suggest reviewers for this pull request"
    },
    // BITBUCKET_PULL_REQUESTS
    bitbucketPullRequestsPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-1",
        defaultMessage: "Summarize this pull request"
    },
    bitbucketPullRequestsPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-2",
        defaultMessage: "Explain the code changes to me."
    },
    bitbucketPullRequestsPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-3",
        defaultMessage: "Summarize the comments on this pull request"
    },
    bitbucketPullRequestsPrompt4: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-4",
        defaultMessage: "Explain the code changes"
    },
    bitbucketPullRequestsPrompt5: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-5-1",
        defaultMessage: "Summarize the build logs"
    },
    bitbucketPullRequestsPrompt6: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-6",
        defaultMessage: "Suggest reviewers for this pull request"
    },
    // BITBUCKET_REPOSITORY_SOURCE
    bitbucketRepositorySourcePrompt1: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-1",
        defaultMessage: "Explain this file"
    },
    bitbucketRepositorySourcePrompt2: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-2",
        defaultMessage: "What are the pull requests authored by `person`?"
    },
    bitbucketRepositorySourcePrompt3: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-3",
        defaultMessage: " What APIs or modules do these files interact with?"
    },
    bitbucketRepositorySourcePrompt4: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-4",
        defaultMessage: "Find pull requests authored by `person`"
    },
    bitbucketRepositorySourcePrompt5: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-5",
        defaultMessage: "Find APIs that these files interact with"
    },
    // BITBUCKET_PIPELINES
    bitbucketPipelinePrompt1: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-pipelines.starter-1-1",
        defaultMessage: "Summarize the build logs"
    },
    bitbucketPipelinePrompt2: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-pipelines.starter-2",
        defaultMessage: "What is the status of the `build`?"
    },
    // BITBUCKET_HOME
    bitbucketPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket.starter-1",
        defaultMessage: "What are the pull requests authored by `person`?"
    },
    bitbucketPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket.starter-2",
        defaultMessage: "What are the open PRs for the current Jira sprint?"
    },
    bitbucketPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket.starter-3",
        defaultMessage: "Has `Jira work item` been deployed?"
    },
    bitbucketPrompt4: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket.starter-4",
        defaultMessage: "Who are the reviewers on this `Pull request`?"
    },
    bitbucketPrompt5: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket.starter-5",
        defaultMessage: "Find pull requests authored by `person`"
    },
    bitbucketPrompt6: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket.starter-6",
        defaultMessage: "Check deployment status of `Jira work item`"
    },
    bitbucketPrompt7: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket.starter-7",
        defaultMessage: "Find reviewers of `pull request`"
    },
    // CONFLUENCE_HOME
    confluenceHomePrompt1: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-1",
        defaultMessage: "Is there any new activity on pages I've written?"
    },
    confluenceHomePrompt2: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-2",
        defaultMessage: "Are there any new comments mentioning me?"
    },
    confluenceHomePrompt3: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-3",
        defaultMessage: "Summarize the most recently published pages in this space."
    },
    confluenceHomePrompt4: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-4",
        defaultMessage: "Summarize my contributions to pages from last week."
    },
    confluenceHomePrompt5: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-5",
        defaultMessage: "Can you take this `page` and write it in a less technical way?"
    },
    confluenceHomePrompt6: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-6",
        defaultMessage: "Create a game plan template for project management."
    },
    confluenceHomePrompt7: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-7",
        defaultMessage: "What research do we have on common customer problems?"
    },
    confluenceHomePrompt8: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-8",
        defaultMessage: "Has anyone on my team published any new pages this week?"
    },
    confluenceHomePrompt9: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-9",
        defaultMessage: "Has `person` published any new pages this week?"
    },
    confluenceHomePrompt10: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-10",
        defaultMessage: "Has `person` commented on any pages that I've published?"
    },
    confluenceHomePrompt11: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-11",
        defaultMessage: "What are the key takeaways from `page`?"
    },
    confluenceHomePrompt12: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-12",
        defaultMessage: "What should I work on next?"
    },
    // CONFLUENCE_PAGE_VIEW & CONFLUENCE_BLOG_VIEW
    confluencePageViewPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-view.starter-1",
        defaultMessage: "Summarize what I'm looking at."
    },
    confluencePageViewPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-view.starter-2",
        defaultMessage: "Summarize the comments on this page."
    },
    confluencePageViewPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-view.starter-3",
        defaultMessage: "Explain this page to me like I'm a beginner."
    },
    confluencePageViewPrompt4: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-view.starter-4",
        defaultMessage: "Who wrote this page and what team are they on?"
    },
    confluencePageViewPrompt5: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-view.starter-5",
        defaultMessage: "Has anything on this page changed in the last week?"
    },
    confluencePageViewPrompt6: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-view.starter-6",
        defaultMessage: "What should I work on next?"
    },
    // CONFLUENCE_PAGE_EDIT & CONFLUENCE_BLOG_EDIT
    confluencePageEditPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-edit.starter-1",
        defaultMessage: "Can you improve the writing on this page?"
    },
    confluencePageEditPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-edit.starter-2",
        defaultMessage: "Write an executive summary for this page."
    },
    confluencePageEditPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-edit.starter-3",
        defaultMessage: "Give me links to some other relevant pages."
    },
    confluencePageEditPrompt4: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-edit.starter-4",
        defaultMessage: "What should I work on next?"
    },
    // CONFLUENCE_WHITEBOARD
    confluenceWhiteboardPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.confluence-whiteboard.starter-1",
        defaultMessage: "Summarize what I'm looking at."
    },
    confluenceWhiteboardPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.confluence-whiteboard.starter-2",
        defaultMessage: "Highlight any patterns or trends visible here."
    },
    confluenceWhiteboardPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.confluence-whiteboard.starter-3",
        defaultMessage: "Identify any key action items or decisions captured in this whiteboard."
    },
    confluenceWhiteboardPrompt4: {
        id: "rovo-conversation-actions.conversation-starters.confluence-whiteboard.starter-4",
        defaultMessage: "What should I work on next?"
    },
    // JIRA_HOME
    jiraHomePrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jira-home.starter-1",
        defaultMessage: "Find Jira issues that have been updated this week."
    },
    jiraHomePrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jira-home.starter-2",
        defaultMessage: "What Jira issues are the highest priority?"
    },
    jiraHomePrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jira-home.starter-3",
        defaultMessage: "What Jira issues have comments mentioning me?"
    },
    jiraHomePrompt4: {
        id: "rovo-conversation-actions.conversation-starters.jira-home.starter-4",
        defaultMessage: "Summarize the comments on `Jira issue`."
    },
    jiraHomePrompt5: {
        id: "rovo-conversation-actions.conversation-starters.jira-home.starter-5",
        defaultMessage: "Create a description template for user stories."
    },
    jiraHomePrompt6: {
        id: "rovo-conversation-actions.conversation-starters.jira-home.starter-6",
        defaultMessage: "What should I work on next?"
    },
    // JIRA_ISSUE_VIEW
    jiraIssueViewPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jira-issue-view.starter-1",
        defaultMessage: "Are there any similar Jira issues to this one?"
    },
    jiraIssueViewPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jira-issue-view.starter-2",
        defaultMessage: "How could I improve the description?"
    },
    jiraIssueViewPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jira-issue-view.starter-3",
        defaultMessage: "What labels could I add to this issue?"
    },
    jiraIssueViewPrompt4: {
        id: "rovo-conversation-actions.conversation-starters.jira-issue-view.starter-4",
        defaultMessage: "What should I work on next?"
    },
    // JIRA_PROJECT
    jiraProjectPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-1",
        defaultMessage: "What work hasn\u2019t been picked up in a while?"
    },
    jiraProjectPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-2",
        defaultMessage: "Are any Jira issues blocked?"
    },
    jiraProjectPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-3",
        defaultMessage: "List Jira issues that are currently \u201CIn Progress\u201D and group them by assignee."
    },
    jiraProjectPrompt4: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-4",
        defaultMessage: "How many issues are assigned to `person`?"
    },
    jiraProjectPrompt5: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-5",
        defaultMessage: "Has `person` commented on any Jira issues in this sprint?"
    },
    jiraProjectPrompt6: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-6",
        defaultMessage: "What Jira issues are unassigned?"
    },
    jiraProjectPrompt7: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-7",
        defaultMessage: "What Jira issues have been open the longest?"
    },
    jiraProjectPrompt8: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-8",
        defaultMessage: "Who has the most tasks?"
    },
    jiraProjectPrompt9: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-9",
        defaultMessage: "Find and group similar Jira issues."
    },
    jiraProjectPrompt10: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-10",
        defaultMessage: "Are there any Jira issues not connected to a parent issue?"
    },
    jiraProjectPrompt11: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-11",
        defaultMessage: "Take `Jira issue` description and align it to best-practice."
    },
    jiraProjectPrompt12: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-12",
        defaultMessage: "Summarize the comments on `Jira issue`."
    },
    jiraProjectPrompt13: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-13",
        defaultMessage: "Create a description template for user stories."
    },
    jiraProjectPrompt14: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-14",
        defaultMessage: "What should I work on next?"
    },
    // JIRA_BOARD
    jiraBoardPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jira-board.starter-1",
        defaultMessage: "Update status for work items in this board."
    },
    jiraBoardPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jira-board.starter-2",
        defaultMessage: "Update assignee for work items in this board."
    },
    jiraBoardPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jira-board.starter-3",
        defaultMessage: "Update work items in this board."
    },
    jiraBoardPrompt4: {
        id: "rovo-conversation-actions.conversation-starters.jira-board.starter-4",
        defaultMessage: "What are the risks for this active sprint?"
    },
    jiraBoardPrompt5: {
        id: "rovo-conversation-actions.conversation-starters.jira-board.starter-5",
        defaultMessage: "How many work items are unassigned in this board?"
    },
    jiraBoardPrompt6: {
        id: "rovo-conversation-actions.conversation-starters.jira-board.starter-6",
        defaultMessage: "Which work items are stale?"
    },
    jiraBoardPrompt7: {
        id: "rovo-conversation-actions.conversation-starters.jira-board.starter-7",
        defaultMessage: "Which work items are blocked?"
    },
    jiraBoardPrompt8: {
        id: "rovo-conversation-actions.conversation-starters.jira-board.starter-8",
        defaultMessage: "Summarize this board for me."
    },
    jiraBoardPrompt9: {
        id: "rovo-conversation-actions.conversation-starters.jira-board.starter-9",
        defaultMessage: "Update work items on this board."
    },
    jiraBoardPrompt10: {
        id: "rovo-conversation-actions.conversation-starters.jira-board.starter-10",
        defaultMessage: "Move work items to a status."
    },
    // JSM_INCIDENT_VIEW
    jsmIncidentViewPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jsm-incident-view.starter-1",
        defaultMessage: "Find people who can help resolve this incident"
    },
    jsmIncidentViewPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jsm-incident-view.starter-2",
        defaultMessage: "Are there any ongoing incidents?"
    },
    jsmIncidentViewPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jsm-incident-view.starter-3",
        defaultMessage: "Create a post-incident review (PIR)"
    },
    // JSM_INCIDENT_LIST_VIEW
    jsmIncidentListViewPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jsm-incident-list-view.starter-1",
        defaultMessage: "Are there any ongoing incidents?"
    },
    jsmIncidentListViewPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jsm-incident-list-view.starter-2",
        defaultMessage: "Get me the open high priority incidents"
    },
    jsmIncidentListViewPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jsm-incident-list-view.starter-3",
        defaultMessage: "Are there any open alerts?"
    },
    // JSM_ALERT_VIEW (Alert details page)
    jsmAlertViewPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-view.starter-1",
        defaultMessage: "Find open alerts"
    },
    jsmAlertViewPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-view.starter-2",
        defaultMessage: "Investigate this alert"
    },
    jsmAlertViewPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-view.starter-3",
        defaultMessage: "Are there any ongoing incidents?"
    },
    // JSM_ALERT_LIST_VIEW (Alert list page)
    jsmAlertListViewPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-list-view.starter-1",
        defaultMessage: "Find open alerts"
    },
    jsmAlertListViewPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-list-view.starter-2",
        defaultMessage: "Find recently closed alerts"
    },
    jsmAlertListViewPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-list-view.starter-3",
        defaultMessage: "Are there any ongoing incidents?"
    },
    // JSM_ALERT_GROUP_DETAIL_VIEW (Alert group details page)
    jsmAlertGroupDetailViewPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-group-detail-view.starter-1",
        defaultMessage: "Find open alerts"
    },
    jsmAlertGroupDetailViewPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-group-detail-view.starter-2",
        defaultMessage: "Find recently closed alerts"
    },
    jsmAlertGroupDetailViewPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-group-detail-view.starter-3",
        defaultMessage: "Are there any ongoing incidents?"
    },
    // ATLAS HOME
    atlasHomePrompt1: {
        id: "rovo-conversation-actions.conversation-starters.atlas-home.starter-1",
        defaultMessage: "What Confluence pages have I contributed to recently?"
    },
    atlasHomePrompt2: {
        id: "rovo-conversation-actions.conversation-starters.atlas-home.starter-2",
        defaultMessage: "Find all Jira tickets that are assigned to me."
    },
    atlasHomePrompt3: {
        id: "rovo-conversation-actions.conversation-starters.atlas-home.starter-3",
        defaultMessage: "What is our travel policy?"
    },
    atlasHomePrompt4: {
        id: "rovo-conversation-actions.conversation-starters.atlas-home.starter-4",
        defaultMessage: "Draft a Confluence page for a marketing campaign."
    },
    atlasHomePrompt5: {
        id: "rovo-conversation-actions.conversation-starters.atlas-home.starter-5",
        defaultMessage: "How can I create a project timeline?"
    },
    atlasHomePrompt6: {
        id: "rovo-conversation-actions.conversation-starters.atlas-home.starter-6",
        defaultMessage: "Write a follow up email to potential clients."
    },
    atlasHomePrompt7: {
        id: "rovo-conversation-actions.conversation-starters.atlas-home.starter-7",
        defaultMessage: "What should I work on next?"
    },
    // FOCUS
    focusPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.focus.starter-1",
        defaultMessage: "Summarize my focus areas."
    },
    focusPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.focus.starter-2",
        defaultMessage: "Identify gaps and highlight risks."
    },
    // FOCUS_FOCUS_AREA_PAGE
    focusAreaPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.focus-area.starter-1",
        defaultMessage: "Summarize this focus area."
    },
    // FOCUS_FOCUS_AREA_GOAL_VIEW
    focusAreaGoalPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.focus-area-goal.starter-1",
        defaultMessage: "Summarize the goals linked to this focus area."
    },
    // FOCUS_FOCUS_AREA_WORK_VIEW
    focusAreaWorkPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.focus-area-work.starter-1",
        defaultMessage: "Summarize the work linked to this focus area."
    },
    // FOCUS_FOCUS_AREA_FUNDS_VIEW
    focusAreaFundsPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.focus-area-funds.starter-1",
        defaultMessage: "Analyze the funds linked to this focus area."
    },
    focusAreaFundsBetaBadge: {
        id: "rovo-conversation-actions.conversation-starters.focus-area-funds.beta-badge",
        defaultMessage: "Beta"
    },
    // FOCUS_FOR_YOU
    focusForYouPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.focus-for-you.starter-1",
        defaultMessage: "Summarize my focus areas."
    },
    // SAC
    sacPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.sac.starter-1",
        defaultMessage: "How do I manage settings?"
    },
    sacPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.sac.starter-2",
        defaultMessage: "How do I find information?"
    },
    sacPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.sac.starter-3",
        defaultMessage: "How do I create an automation rule?"
    },
    // TRELLO_BOARD (board/universal rovo button)
    trelloBoardPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.trello-board.starter-1",
        defaultMessage: "Summarize this board."
    },
    trelloBoardPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.trello-board.starter-2",
        defaultMessage: "Suggest ways to organize this board."
    },
    trelloBoardPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.trello-board.starter-3",
        defaultMessage: "What should my top 3 priorities be today?"
    },
    // TRELLO_CARD (cardback)
    trelloCardPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.trello-card.starter-1",
        defaultMessage: "Summarize this card."
    },
    trelloCardPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.trello-card.starter-2",
        defaultMessage: "Find work related to this card."
    },
    trelloCardPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.trello-card.starter-3",
        defaultMessage: "Suggest improvements for this card's description."
    },
    // UNKNOWN
    unknownPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.unknown.starter-1",
        defaultMessage: "Are any of my work items overdue?"
    },
    unknownPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.unknown.starter-2",
        defaultMessage: "What should I work on next?"
    },
    unknownPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.unknown.starter-3",
        defaultMessage: "Write an update about my week."
    },
    studioAgentBuilderPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.studio-agent-builder.starter-1",
        defaultMessage: "Personalize this agent to my needs"
    },
    studioAgentBuilderPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.studio-agent-builder.starter-2",
        defaultMessage: "What other tools could I add"
    },
    studioAgentBuilderPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.studio-agent-builder.starter-3",
        defaultMessage: "Find more knowledge sources"
    }
});
var $b0ccb00ee4479897$export$2e2bcd8739ae039 = $b0ccb00ee4479897$var$_default_1;
module.exports["default"] = $b0ccb00ee4479897$export$2e2bcd8739ae039;

});

parcelRegister("gxmD5", function(module, exports) {
const $2f7f93fb83392ebb$export$cb9fc4c34a0afb34 = {
    lastSeenAt: 0,
    exposureCount: 0,
    onboardingCompleted: false
};
module.exports["DEFAULT_HOLDOUT_STATE"] = $2f7f93fb83392ebb$export$cb9fc4c34a0afb34;

});

parcelRegister("advdT", function(module, exports) {

var $7dBf8 = parcelRequire("7dBf8");


var $9O4fI = parcelRequire("9O4fI");


var $aWbI3 = parcelRequire("aWbI3");

function $35b5f67ffede8a05$export$70098a1ba52d021f() {
    try {
        return (0, $aWbI3.parseState)((0, $7dBf8.AtlBrowserStorageLocal).getItem((0, $9O4fI.LS_ONBOARDING_HOLDOUT_KEY)));
    } catch  {
        return null;
    }
}
module.exports["getOnboardingHoldoutState"] = $35b5f67ffede8a05$export$70098a1ba52d021f;

});

parcelRegister("9O4fI", function(module, exports) {
/**
 * Onboarding holdout feature: gate onboarding behind a 24h cooldown, a max of 3 exposures,
 * and don't-show-again-after-completion. This module defines the holdout tunables
 * (cooldown, exposure cap, storage key) and the persisted state shape. State is read/written
 * via the get/persist helpers using AtlBrowserStorageLocal; if productionized, consider a more
 * permanent source (e.g. backend or user preferences).
 */ 
var $oV0CU = parcelRequire("oV0CU");

const $1243988fe5d236ac$export$124df12a015901ba = 'rovoOnboardingHoldout';
const $1243988fe5d236ac$export$a478a0028a108fe6 = 3;
const $1243988fe5d236ac$export$af9030d6dd88ec25 = 24 * (0, $oV0CU.SECONDS_IN_HR) * (0, $oV0CU.MS_IN_SECOND);
module.exports["LS_ONBOARDING_HOLDOUT_KEY"] = $1243988fe5d236ac$export$124df12a015901ba;
module.exports["MAX_ONBOARDING_EXPOSURES"] = $1243988fe5d236ac$export$a478a0028a108fe6;
module.exports["HOLDOUT_MS"] = $1243988fe5d236ac$export$af9030d6dd88ec25;

});

parcelRegister("aWbI3", function(module, exports) {

var $9O4fI = parcelRequire("9O4fI");

function $12e24d7a304110aa$export$adb402f717f36848(raw) {
    if (raw === null) return null;
    const parsed = JSON.parse(raw);
    if (typeof parsed.lastSeenAt === 'number' && typeof parsed.exposureCount === 'number') return {
        lastSeenAt: parsed.lastSeenAt,
        exposureCount: Math.min(Math.max(0, Math.floor(parsed.exposureCount)), (0, $9O4fI.MAX_ONBOARDING_EXPOSURES)),
        onboardingCompleted: parsed.onboardingCompleted === true
    };
    return null;
}
module.exports["parseState"] = $12e24d7a304110aa$export$adb402f717f36848;

});

parcelRegister("3LpEG", function(module, exports) {

var $7dBf8 = parcelRequire("7dBf8");


var $9O4fI = parcelRequire("9O4fI");

function $a9ad9738d21e6d42$export$9f127573fd964184(state) {
    try {
        (0, $7dBf8.AtlBrowserStorageLocal).setItem((0, $9O4fI.LS_ONBOARDING_HOLDOUT_KEY), JSON.stringify(state));
    } catch  {
    // AtlBrowserStorageLocal may be full or unavailable (e.g. private browsing in Safari)
    }
}
module.exports["persistState"] = $a9ad9738d21e6d42$export$9f127573fd964184;

});

parcelRegister("7o2Oy", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $cbY7C = parcelRequire("cbY7C");


var $kSwu1 = parcelRequire("kSwu1");


var $1hQ0e = parcelRequire("1hQ0e");


var $iODl6 = parcelRequire("iODl6");


var $j72ee = parcelRequire("j72ee");


var $hBYtq = parcelRequire("hBYtq");


var $oV0CU = parcelRequire("oV0CU");


var $Vl9MW = parcelRequire("Vl9MW");


var $6FfVp = parcelRequire("6FfVp");

const $abb6876f0c761819$var$SPLIT_LAYOUT_RESIZE_HANDLE_WIDTH = 4;
const $abb6876f0c761819$var$messages = (0, $kSwu1.defineMessages)({
    resizeSidePanelAriaLabel: {
        id: "ai-mate.conversation-assistant.split-layout.resize-side-panel-aria-label",
        defaultMessage: "Resize side panel"
    }
});
const $abb6876f0c761819$var$styles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _vchhusvi _1wpz1fhb _4t3i1osq _1bsb1osq _1tkeidpf _1ul9idpf _1e0c1txw _2lx2vrvc _4cvr1fhb",
    leftPane: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1wpz1fhb _4t3i1osq _1tkeidpf _1ul9idpf _1e0c1txw _2lx21bp4 _4cvr1fhb",
    rightPanel: "_16jlidpf _1o9zidpf _i0dl1wug _1reo15vq _18m915vq _vchhusvi _1wpz1fhb _4t3i1osq _1tkeidpf _1ul9idpf _1e0c1txw _2lx21bp4 _4cvr1fhb _t6vde4h9 _1p3lnqa1 _5wra1l7x",
    resizeHandle: "_19itglyw _v5642hjt _1bsb1y44 _1wpz1fhb _kqswh2mm _80om11mm _bfhk1j28 _qc5o2hjt _aetrb3bt _18postnw _19do1ssb _15l2idpf _1x88idpf _z0aiyh40 _1hfk1j28 _clh3zr6s _4tpu1856",
    resizeHandleDragging: "_1hfk1856"
};
const $abb6876f0c761819$var$isBrowser = typeof window !== 'undefined';
const $abb6876f0c761819$var$readPersistedWidth = (storageKey)=>{
    if (!storageKey || !$abb6876f0c761819$var$isBrowser) return null;
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        const raw = window.localStorage.getItem(storageKey);
        if (raw == null) return null;
        const parsed = Number.parseFloat(raw);
        return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
    } catch  {
        return null;
    }
};
const $abb6876f0c761819$var$writePersistedWidth = (storageKey, width)=>{
    if (!storageKey || !$abb6876f0c761819$var$isBrowser) return;
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        window.localStorage.setItem(storageKey, String(Math.round(width)));
    } catch  {}
}; /**
    * Renders a horizontal split layout:
    *   [ chat children (flex-grow left pane) ] [ resize handle ] [ right panel (sized) ]
    *
    * - The chat (left) uses `flex: 1` so it always absorbs surplus horizontal
    *   space and is the visually dominant pane.
    * - The right panel has an explicit pixel width that the user can drag.
    *
    * The drag math is a mirror of `useResizablePanel`: `rightWidth = containerRight
    * - clientX`, clamped so the chat keeps at least `minWidth`, the right panel keeps at least
    * `adjacentMinWidth`, and the right panel never becomes wider than the chat.
    */ 
const $abb6876f0c761819$export$581077d6f0ab5bc7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(49);
    const { initialWidth: t1, minWidth: t2, adjacentMinWidth: t3, storageKey: storageKey, children: children, isRightPanelVisible: t4, onAutoCollapse: onAutoCollapse, rightPanelExitHandlerRef: rightPanelExitHandlerRef } = t0;
    const initialWidth = t1 === undefined ? 380 : t1;
    const minWidth = t2 === undefined ? 480 : t2;
    const adjacentMinWidth = t3 === undefined ? 280 : t3;
    const isRightPanelVisible = t4 === undefined ? true : t4;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const containerRef = (0, $cozmU.useRef)(null);
    const onAutoCollapseRef = (0, $cozmU.useRef)(onAutoCollapse);
    let t5;
    if ($[0] !== adjacentMinWidth || $[1] !== initialWidth || $[2] !== storageKey) {
        t5 = ()=>{
            const persisted = $abb6876f0c761819$var$readPersistedWidth(storageKey);
            const seed = persisted ?? initialWidth;
            return Math.max(seed, adjacentMinWidth);
        };
        $[0] = adjacentMinWidth;
        $[1] = initialWidth;
        $[2] = storageKey;
        $[3] = t5;
    } else t5 = $[3];
    const [rightWidth, setRightWidth] = (0, $cozmU.useState)(t5);
    const [isDragging, setIsDragging] = (0, $cozmU.useState)(false);
    const [isRightPanelMounted, setIsRightPanelMounted] = (0, $cozmU.useState)(isRightPanelVisible);
    const rightWidthRef = (0, $cozmU.useRef)(rightWidth);
    let t6;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (e)=>{
            e.preventDefault();
            setIsDragging(true);
        };
        $[4] = t6;
    } else t6 = $[4];
    const handleMouseDown = t6;
    let t7;
    if ($[5] !== adjacentMinWidth || $[6] !== isDragging || $[7] !== minWidth) {
        t7 = (e_0)=>{
            if (!isDragging || !containerRef.current) return;
            const rect = containerRef.current.getBoundingClientRect();
            const proposed = rect.right - e_0.clientX;
            const maxRight = Math.max(adjacentMinWidth, Math.min(rect.width - minWidth, (rect.width - $abb6876f0c761819$var$SPLIT_LAYOUT_RESIZE_HANDLE_WIDTH) / 2));
            setRightWidth(Math.max(adjacentMinWidth, Math.min(maxRight, proposed)));
        };
        $[5] = adjacentMinWidth;
        $[6] = isDragging;
        $[7] = minWidth;
        $[8] = t7;
    } else t7 = $[8];
    const handleMouseMove = t7;
    let t8;
    if ($[9] !== storageKey) {
        t8 = ()=>{
            setIsDragging(false);
            $abb6876f0c761819$var$writePersistedWidth(storageKey, rightWidthRef.current);
        };
        $[9] = storageKey;
        $[10] = t8;
    } else t8 = $[10];
    const handleMouseUp = t8;
    let t10;
    let t9;
    if ($[11] !== isRightPanelVisible) {
        t9 = ()=>{
            if (isRightPanelVisible) setIsRightPanelMounted(true);
        };
        t10 = [
            isRightPanelVisible
        ];
        $[11] = isRightPanelVisible;
        $[12] = t10;
        $[13] = t9;
    } else {
        t10 = $[12];
        t9 = $[13];
    }
    (0, $cozmU.useEffect)(t9, t10);
    let t11;
    let t12;
    if ($[14] !== rightWidth) {
        t11 = ()=>{
            rightWidthRef.current = rightWidth;
        };
        t12 = [
            rightWidth
        ];
        $[14] = rightWidth;
        $[15] = t11;
        $[16] = t12;
    } else {
        t11 = $[15];
        t12 = $[16];
    }
    (0, $cozmU.useEffect)(t11, t12);
    let t13;
    let t14;
    if ($[17] !== onAutoCollapse) {
        t13 = ()=>{
            onAutoCollapseRef.current = onAutoCollapse;
        };
        t14 = [
            onAutoCollapse
        ];
        $[17] = onAutoCollapse;
        $[18] = t13;
        $[19] = t14;
    } else {
        t13 = $[18];
        t14 = $[19];
    }
    (0, $cozmU.useEffect)(t13, t14);
    let t15;
    let t16;
    if ($[20] !== isRightPanelVisible) {
        t15 = ()=>{
            if (!isRightPanelVisible || !$abb6876f0c761819$var$isBrowser || typeof ResizeObserver === "undefined") return;
            const container = containerRef.current;
            if (!container) return;
            let previousWidth = null;
            const observer = new ResizeObserver((entries)=>{
                for (const entry of entries){
                    const { width: width } = entry.contentRect;
                    const isShrinking = previousWidth !== null && width < previousWidth;
                    if (isShrinking && width < (0, $oV0CU.SPLIT_LAYOUT_MIN_PANEL_WIDTH)) onAutoCollapseRef.current?.();
                    previousWidth = width;
                }
            });
            observer.observe(container);
            return ()=>{
                observer.disconnect();
            };
        };
        t16 = [
            isRightPanelVisible
        ];
        $[20] = isRightPanelVisible;
        $[21] = t15;
        $[22] = t16;
    } else {
        t15 = $[21];
        t16 = $[22];
    }
    (0, $cozmU.useEffect)(t15, t16);
    let t17;
    let t18;
    if ($[23] !== handleMouseMove || $[24] !== handleMouseUp || $[25] !== isDragging) {
        t17 = ()=>{
            if (!isDragging) return;
            const doc = (0, $1hQ0e.getDocument)();
            if (!doc) return;
            const unbindMouseMove = (0, $cbY7C.bind)(doc, {
                type: "mousemove",
                listener: handleMouseMove
            });
            const unbindMouseUp = (0, $cbY7C.bind)(doc, {
                type: "mouseup",
                listener: handleMouseUp
            });
            return ()=>{
                unbindMouseMove();
                unbindMouseUp();
            };
        };
        t18 = [
            isDragging,
            handleMouseMove,
            handleMouseUp
        ];
        $[23] = handleMouseMove;
        $[24] = handleMouseUp;
        $[25] = isDragging;
        $[26] = t17;
        $[27] = t18;
    } else {
        t17 = $[26];
        t18 = $[27];
    }
    (0, $cozmU.useEffect)(t17, t18);
    const t19 = `${rightWidth}px`;
    const t20 = isDragging ? "none" : undefined;
    let t21;
    if ($[28] !== t19 || $[29] !== t20) {
        t21 = {
            width: t19,
            maxWidth: `calc(50% - ${$abb6876f0c761819$var$SPLIT_LAYOUT_RESIZE_HANDLE_WIDTH / 2}px)`,
            pointerEvents: t20
        };
        $[28] = t19;
        $[29] = t20;
        $[30] = t21;
    } else t21 = $[30];
    const rightStyle = t21;
    let t22;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
        t22 = (0, $hekY6.default)([
            $abb6876f0c761819$var$styles.root
        ]);
        $[31] = t22;
    } else t22 = $[31];
    let t23;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
        t23 = (0, $hekY6.default)([
            $abb6876f0c761819$var$styles.leftPane
        ]);
        $[32] = t23;
    } else t23 = $[32];
    let t24;
    if ($[33] !== children) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "conversation-assistant-split-layout-left",
            className: t23
        }, children);
        $[33] = children;
        $[34] = t24;
    } else t24 = $[34];
    let t25;
    if ($[35] !== formatMessage || $[36] !== isDragging || $[37] !== isRightPanelMounted) {
        t25 = isRightPanelMounted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: (0, $k12R1.cx)($abb6876f0c761819$var$styles.resizeHandle, isDragging && $abb6876f0c761819$var$styles.resizeHandleDragging),
            "data-dragging": isDragging,
            testId: "conversation-assistant-split-layout-resize-handle",
            onMouseDown: handleMouseDown,
            "aria-label": formatMessage($abb6876f0c761819$var$messages.resizeSidePanelAriaLabel)
        });
        $[35] = formatMessage;
        $[36] = isDragging;
        $[37] = isRightPanelMounted;
        $[38] = t25;
    } else t25 = $[38];
    let t26;
    if ($[39] !== isRightPanelVisible || $[40] !== rightPanelExitHandlerRef || $[41] !== rightStyle) {
        t26 = isRightPanelVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j72ee.default), {
            enterFrom: "right",
            fade: "inout",
            duration: "medium",
            onFinish: (state)=>{
                if (state === "exiting") {
                    setIsRightPanelMounted(false);
                    const exitHandler = rightPanelExitHandlerRef?.current;
                    if (rightPanelExitHandlerRef) rightPanelExitHandlerRef.current = null;
                    exitHandler?.();
                }
            }
        }, (t27)=>{
            const { className: className, ref: ref } = t27;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                className: (0, $hekY6.default)([
                    $abb6876f0c761819$var$styles.rightPanel,
                    className
                ]),
                ref: ref,
                "data-testid": "conversation-assistant-split-layout-right",
                style: rightStyle
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6FfVp.SessionRightPanelSkeleton), null)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Vl9MW.SessionRightPanelLazy), null)));
        });
        $[39] = isRightPanelVisible;
        $[40] = rightPanelExitHandlerRef;
        $[41] = rightStyle;
        $[42] = t26;
    } else t26 = $[42];
    let t27;
    if ($[43] !== t26) {
        t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
            appear: true
        }, t26);
        $[43] = t26;
        $[44] = t27;
    } else t27 = $[44];
    let t28;
    if ($[45] !== t24 || $[46] !== t25 || $[47] !== t27) {
        t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "conversation-assistant-split-layout",
            ref: containerRef,
            className: t22
        }, t24, t25, t27);
        $[45] = t24;
        $[46] = t25;
        $[47] = t27;
        $[48] = t28;
    } else t28 = $[48];
    return t28;
} : ({ initialWidth: initialWidth = 380, minWidth: minWidth = 480, adjacentMinWidth: adjacentMinWidth = 280, storageKey: storageKey, children: children, isRightPanelVisible: isRightPanelVisible = true, onAutoCollapse: onAutoCollapse, rightPanelExitHandlerRef: rightPanelExitHandlerRef })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const containerRef = (0, $cozmU.useRef)(null); // Mirror the callback to a ref so the resize observer below doesn't need to re-subscribe every time the host passes a new callback identity.
    const onAutoCollapseRef = (0, $cozmU.useRef)(onAutoCollapse); // Lazy initializer so we only touch `localStorage` once on mount. The persisted value (if any) wins over the explicit `initialWidth` prop.
    const [rightWidth, setRightWidth] = (0, $cozmU.useState)(()=>{
        const persisted = $abb6876f0c761819$var$readPersistedWidth(storageKey);
        const seed = persisted ?? initialWidth;
        return Math.max(seed, adjacentMinWidth);
    });
    const [isDragging, setIsDragging] = (0, $cozmU.useState)(false);
    const [isRightPanelMounted, setIsRightPanelMounted] = (0, $cozmU.useState)(isRightPanelVisible); // Latest width is mirrored to a ref so the `mouseup` handler can persist without being recreated (and re-binding listeners) on every drag tick.
    const rightWidthRef = (0, $cozmU.useRef)(rightWidth);
    const handleMouseDown = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        setIsDragging(true);
    }, []);
    const handleMouseMove = (0, $cozmU.useCallback)((e_0)=>{
        if (!isDragging || !containerRef.current) return;
        const rect = containerRef.current.getBoundingClientRect();
        const proposed = rect.right - e_0.clientX;
        const maxRight = Math.max(adjacentMinWidth, Math.min(rect.width - minWidth, (rect.width - $abb6876f0c761819$var$SPLIT_LAYOUT_RESIZE_HANDLE_WIDTH) / 2));
        setRightWidth(Math.max(adjacentMinWidth, Math.min(maxRight, proposed)));
    }, [
        isDragging,
        minWidth,
        adjacentMinWidth
    ]);
    const handleMouseUp = (0, $cozmU.useCallback)(()=>{
        setIsDragging(false); // Persist the resting width once per drag (not on every mousemove tick).
        $abb6876f0c761819$var$writePersistedWidth(storageKey, rightWidthRef.current);
    }, [
        storageKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isRightPanelVisible) setIsRightPanelMounted(true);
    }, [
        isRightPanelVisible
    ]);
    (0, $cozmU.useEffect)(()=>{
        rightWidthRef.current = rightWidth;
    }, [
        rightWidth
    ]);
    (0, $cozmU.useEffect)(()=>{
        onAutoCollapseRef.current = onAutoCollapse;
    }, [
        onAutoCollapse
    ]); // When the panel the chat lives in is resized narrower than the split-layout minimum, auto-collapse the right panel
    (0, $cozmU.useEffect)(()=>{
        if (!isRightPanelVisible || !$abb6876f0c761819$var$isBrowser || typeof ResizeObserver === 'undefined') return;
        const container = containerRef.current;
        if (!container) return;
         // Collapse the right panel only when the user actively *narrows* the container below the split
        // minimum — i.e. the width is shrinking. Acting on the shrink direction (rather than any narrow
        // reading) means we ignore the panel growing as it expands on open, so a just-opened split is
        // never collapsed mid-expansion, and a split that simply opened narrow isn't yanked away —
        // only a deliberate narrowing hides it.
        let previousWidth = null;
        const observer = new ResizeObserver((entries)=>{
            for (const entry of entries){
                const { width: width } = entry.contentRect;
                const isShrinking = previousWidth !== null && width < previousWidth;
                if (isShrinking && width < (0, $oV0CU.SPLIT_LAYOUT_MIN_PANEL_WIDTH)) onAutoCollapseRef.current?.();
                previousWidth = width;
            }
        });
        observer.observe(container);
        return ()=>{
            observer.disconnect();
        };
    }, [
        isRightPanelVisible
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isDragging) return;
        const doc = (0, $1hQ0e.getDocument)();
        if (!doc) return;
        const unbindMouseMove = (0, $cbY7C.bind)(doc, {
            type: 'mousemove',
            listener: handleMouseMove
        });
        const unbindMouseUp = (0, $cbY7C.bind)(doc, {
            type: 'mouseup',
            listener: handleMouseUp
        });
        return ()=>{
            unbindMouseMove();
            unbindMouseUp();
        };
    }, [
        isDragging,
        handleMouseMove,
        handleMouseUp
    ]);
    const rightStyle = {
        width: `${rightWidth}px`,
        maxWidth: `calc(50% - ${$abb6876f0c761819$var$SPLIT_LAYOUT_RESIZE_HANDLE_WIDTH / 2}px)`,
        pointerEvents: isDragging ? 'none' : undefined
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "conversation-assistant-split-layout",
        ref: containerRef,
        className: (0, $hekY6.default)([
            $abb6876f0c761819$var$styles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "conversation-assistant-split-layout-left",
        className: (0, $hekY6.default)([
            $abb6876f0c761819$var$styles.leftPane
        ])
    }, children), isRightPanelMounted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: (0, $k12R1.cx)($abb6876f0c761819$var$styles.resizeHandle, isDragging && $abb6876f0c761819$var$styles.resizeHandleDragging),
        "data-dragging": isDragging,
        testId: "conversation-assistant-split-layout-resize-handle",
        onMouseDown: handleMouseDown,
        "aria-label": formatMessage($abb6876f0c761819$var$messages.resizeSidePanelAriaLabel)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
        appear: true
    }, isRightPanelVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j72ee.default), {
        enterFrom: "right",
        fade: "inout",
        duration: "medium",
        onFinish: (state)=>{
            if (state === 'exiting') {
                setIsRightPanelMounted(false);
                const exitHandler = rightPanelExitHandlerRef?.current;
                if (rightPanelExitHandlerRef) rightPanelExitHandlerRef.current = null;
                exitHandler?.();
            }
        }
    }, ({ className: className, ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- required to forward the motion animation class from @atlaskit/motion's SlideIn render prop
        , {
            className: (0, $hekY6.default)([
                $abb6876f0c761819$var$styles.rightPanel,
                className
            ]),
            ref: ref,
            "data-testid": "conversation-assistant-split-layout-right",
            style: rightStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6FfVp.SessionRightPanelSkeleton), null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Vl9MW.SessionRightPanelLazy), null))))));
};
module.exports["SplitLayout"] = $abb6876f0c761819$export$581077d6f0ab5bc7;

});

parcelRegister("Vl9MW", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $c519d749112a26b1$export$a0bce28b49dab85d = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("jEDfT")).then((module)=>({
            default: module.SessionRightPanel
        })));
module.exports["SessionRightPanelLazy"] = $c519d749112a26b1$export$a0bce28b49dab85d;

});

parcelRegister("jEDfT", function(module, exports) {

let $e4f034072de307a6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e4f034072de307a6$var$load("3iw68"),
    $e4f034072de307a6$var$load("6wr18"),
    $e4f034072de307a6$var$load("hnxOv"),
    $e4f034072de307a6$var$load("k2NjG"),
    $e4f034072de307a6$var$load("ffEVr"),
    $e4f034072de307a6$var$load("5CO1V")
]).then(()=>parcelRequire('lBYt7'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("6FfVp", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $I7hWB = parcelRequire("I7hWB");


var $iMnC5 = parcelRequire("iMnC5");

var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");


var $3jCmP = parcelRequire("3jCmP");

const $5b8c79aaf8c3f9d7$var$styles = {
    root: "_4t3i1osq _1bsb1osq _vchhusvi _18m91wug",
    content: "_zulpv47k _2rkopb1k _189ee4h9 _1dqonqa1 _1h6d1l7x _1e0c1txw _2lx21bp4 _19pkv47k _otyrv47k _18u0v47k _2hwxv47k _ca0qv47k _u5f3utpp _n3tdv47k _19bvutpp",
    section: "_zulputpp _1e0c1txw _2lx21bp4",
    pillsContainer: "_zulp1b66 _1e0c1txw _1n261g80",
    pill: "_2rko12b0 _189ee4h9 _1dqonqa1 _1h6d1l7x _1e0c116y _4cvr1h6o _ca0q1b66 _n3td1b66 _19bvu2gc _u5f3u2gc _bfhksm61",
    artefactRow: "_2rkopb1k _zulputpp _189ee4h9 _1dqonqa1 _1h6d1l7x _bozgutpp _y4tiutpp _1tkevbgk _1e0c1txw _4cvr1h6o"
};
const $5b8c79aaf8c3f9d7$var$PILL_CONTENT_WIDTHS = [
    120,
    88,
    162,
    65,
    128
];
const $5b8c79aaf8c3f9d7$export$659bc7cd6c22a575 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(18);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage((0, $3jCmP.default).attachmentsHeading);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, t0);
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $5b8c79aaf8c3f9d7$var$styles.pillsContainer
        }, $5b8c79aaf8c3f9d7$var$PILL_CONTENT_WIDTHS.map($5b8c79aaf8c3f9d7$var$_temp));
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $5b8c79aaf8c3f9d7$var$styles.section
        }, t1, t2);
        $[5] = t1;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== formatMessage) {
        t4 = formatMessage((0, $3jCmP.default).outputHeading);
        $[7] = formatMessage;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, t4);
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = [
            150,
            120,
            160
        ];
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050"
        }, t6.map($5b8c79aaf8c3f9d7$var$_temp2));
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== t5) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $5b8c79aaf8c3f9d7$var$styles.section
        }, t5, t7);
        $[13] = t5;
        $[14] = t8;
    } else t8 = $[14];
    let t9;
    if ($[15] !== t3 || $[16] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $5b8c79aaf8c3f9d7$var$styles.root
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $5b8c79aaf8c3f9d7$var$styles.content
        }, t3, t8));
        $[15] = t3;
        $[16] = t8;
        $[17] = t9;
    } else t9 = $[17];
    return t9;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5b8c79aaf8c3f9d7$var$styles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5b8c79aaf8c3f9d7$var$styles.content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5b8c79aaf8c3f9d7$var$styles.section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $3jCmP.default).attachmentsHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5b8c79aaf8c3f9d7$var$styles.pillsContainer
    }, $5b8c79aaf8c3f9d7$var$PILL_CONTENT_WIDTHS.map((width)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: width,
            xcss: $5b8c79aaf8c3f9d7$var$styles.pill
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: width,
            height: 14,
            isShimmering: true
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5b8c79aaf8c3f9d7$var$styles.section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $3jCmP.default).outputHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, [
        150,
        120,
        160
    ].map((titleWidth)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: titleWidth,
            xcss: $5b8c79aaf8c3f9d7$var$styles.artefactRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 32,
            height: 32,
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.025"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: titleWidth,
            height: 14,
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 100,
            height: 12,
            isShimmering: true
        }))))))));
};
function $5b8c79aaf8c3f9d7$var$_temp(width) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        key: width,
        xcss: $5b8c79aaf8c3f9d7$var$styles.pill
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: width,
        height: 14,
        isShimmering: true
    }));
}
function $5b8c79aaf8c3f9d7$var$_temp2(titleWidth) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        key: titleWidth,
        xcss: $5b8c79aaf8c3f9d7$var$styles.artefactRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 32,
        height: 32,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: titleWidth,
        height: 14,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 100,
        height: 12,
        isShimmering: true
    })));
}
module.exports["SessionRightPanelSkeleton"] = $5b8c79aaf8c3f9d7$export$659bc7cd6c22a575;

});

parcelRegister("3jCmP", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $16e131a014b3f812$var$messages = (0, $kSwu1.defineMessages)({
    attachmentsHeading: {
        id: "ai-mate.conversation-assistant.split-layout.default-right-panel.attachments-heading-non-final",
        defaultMessage: "Attachments"
    },
    outputHeading: {
        id: "ai-mate.conversation-assistant.split-layout.default-right-panel.output-heading-non-final",
        defaultMessage: "Output"
    },
    feedbackBannerText: {
        id: "ai-mate.conversation-assistant.split-layout.default-right-panel.feedback-banner-text-non-final",
        defaultMessage: "\uD83E\uDDEA Internal experiment - Don't demo externally {feedbackChannelLink}"
    }
});
var $16e131a014b3f812$export$2e2bcd8739ae039 = $16e131a014b3f812$var$messages;
module.exports["default"] = $16e131a014b3f812$export$2e2bcd8739ae039;

});

parcelRegister("fBd2O", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");


var $cK21K = parcelRequire("cK21K");


var $8akfd = parcelRequire("8akfd");


var $dSCNl = parcelRequire("dSCNl");


var $dPoYT = parcelRequire("dPoYT");


var $2FUOC = parcelRequire("2FUOC");

const $f5c1836cf94a50bb$var$styles = {
    wrapper: "_vchhusvi _1bsb1ina _19pkpxbi _4t3inau3 _bfhkvuon _1e0c1txw _2lx21bp4 _ae4v1fhb _4cvr1fhb",
    wrapperNav4: "_vchhusvi _1bsb1osq _4t3i1osq _bfhkvuon _1e0c1txw _2lx21bp4 _ae4v1fhb _4cvr1fhb",
    wrapperHeight: "_1tke1edt",
    externalEmbed: "_19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _1bsb1osq _4t3i1osq",
    fullscreenDebug: "_1r04ze3t _kqsw1n9t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _4t3in7od _1bsbn7od",
    withExternalStagingArea: "_1bsb1osq"
};
const $f5c1836cf94a50bb$var$stylesBorder = {
    borderNavV3: "_1h6d1l7x _189ee4h9 _1dqonqa1 _13li1mok _qrwq1mok",
    borderNavV4: "",
    borderFullScreenDebug: "_2rko1mok _1dqonqa1 _1h6d1w55 _189e1mok",
    borderExternalEmbed: "",
    borderStagingArea: "_2rkopb1k _16qst7xp"
};
const $f5c1836cf94a50bb$var$miniModalWrapperStyles = null; // When rendered inside a full-screen MaximisedModal, the modal already provides
// width/height/border-radius/shadow. The wrapper should fill the modal body
// without the sidebar-mode top margin or border-radius.
const $f5c1836cf94a50bb$var$fullScreenModalWrapperStyles = null;
const $f5c1836cf94a50bb$export$6661021c36f0a701 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { testId: testId, children: children, isNav4Enabled: isNav4Enabled, mode: mode } = t0;
    const isMiniModal = mode === (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL;
    const isFullScreenModal = mode === (0, $dPoYT.ConversationAssistantUIModes).FULL_SCREEN_MODAL && (0, $iDrrr.fg)("agent_session_experience_fg");
    const { externalEmbed: externalEmbed, fullScreen: fullScreen, elements: elements, isSplitLayout: isSplitLayout, splitLayoutInitialWidth: splitLayoutInitialWidth, splitLayoutMinWidth: splitLayoutMinWidth, splitLayoutAdjacentMinWidth: splitLayoutAdjacentMinWidth, splitLayoutStorageKey: splitLayoutStorageKey } = (0, $dSCNl.useUIConfig)();
    const { stagingAreaMode: stagingAreaMode } = (0, $8akfd.useStagingAreaState)();
    let t1;
    if ($[0] !== children || $[1] !== isMiniModal || $[2] !== isSplitLayout || $[3] !== splitLayoutAdjacentMinWidth || $[4] !== splitLayoutInitialWidth || $[5] !== splitLayoutMinWidth || $[6] !== splitLayoutStorageKey) {
        t1 = ()=>{
            if (!isSplitLayout || !(0, $iDrrr.fg)("agent_session_experience_fg")) return children;
            return /*#__PURE__*/ $cozmU.createElement((0, $2FUOC.SessionContextLayout), {
                isMiniModal: isMiniModal,
                initialWidth: splitLayoutInitialWidth,
                minWidth: splitLayoutMinWidth,
                adjacentMinWidth: splitLayoutAdjacentMinWidth,
                storageKey: splitLayoutStorageKey
            }, children);
        };
        $[0] = children;
        $[1] = isMiniModal;
        $[2] = isSplitLayout;
        $[3] = splitLayoutAdjacentMinWidth;
        $[4] = splitLayoutInitialWidth;
        $[5] = splitLayoutMinWidth;
        $[6] = splitLayoutStorageKey;
        $[7] = t1;
    } else t1 = $[7];
    const renderInnerChildren = t1;
    const shouldShowStagingArea = stagingAreaMode === "inline";
    const fullscreenDebugEnabled = localStorage.getItem("DEBUG_rovo_chat_fullscreen") === "true" && (0, $iDrrr.fg)("rovo_chat_show_local_frontend_components");
    const shouldUseWrapperNav4Styles = isNav4Enabled;
    if (fullscreenDebugEnabled) {
        const t2 = shouldUseWrapperNav4Styles ? $f5c1836cf94a50bb$var$styles.wrapperNav4 : $f5c1836cf94a50bb$var$styles.wrapper;
        const t3 = isMiniModal ? "_2rko1tm3 _1reo15vq _18m915vq _16qs130s _4t3i1wug _k8m0wor5 _1oec15uc _6fl4indk" : $f5c1836cf94a50bb$var$styles.wrapperHeight;
        const t4 = externalEmbed && $f5c1836cf94a50bb$var$styles.externalEmbed;
        let t5;
        if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
            t5 = (0, $hekY6.default)([
                t2,
                t3,
                t4,
                $f5c1836cf94a50bb$var$styles.fullscreenDebug,
                $f5c1836cf94a50bb$var$stylesBorder.borderFullScreenDebug
            ]);
            $[8] = t2;
            $[9] = t3;
            $[10] = t4;
            $[11] = t5;
        } else t5 = $[11];
        let t6;
        if ($[12] !== renderInnerChildren) {
            t6 = renderInnerChildren();
            $[12] = renderInnerChildren;
            $[13] = t6;
        } else t6 = $[13];
        let t7;
        if ($[14] !== t5 || $[15] !== t6 || $[16] !== testId) {
            t7 = /*#__PURE__*/ $cozmU.createElement((0, $cK21K.default), {
                zIndex: 500
            }, /*#__PURE__*/ $cozmU.createElement("div", {
                "data-testid": testId,
                "data-rovo-chat-panel": "true",
                className: t5
            }, t6));
            $[14] = t5;
            $[15] = t6;
            $[16] = testId;
            $[17] = t7;
        } else t7 = $[17];
        return t7;
    }
    const getBorderStyle = ()=>{
        if (elements?.stagingAreaEnabled) return "borderStagingArea";
        if (externalEmbed) return "borderExternalEmbed";
        if (fullscreenDebugEnabled) return "borderFullScreenDebug";
        if (shouldUseWrapperNav4Styles) return "borderNavV4";
        return "borderNavV3";
    };
    const t2 = "true";
    const t3 = (0, $hekY6.default)([
        shouldUseWrapperNav4Styles ? $f5c1836cf94a50bb$var$styles.wrapperNav4 : $f5c1836cf94a50bb$var$styles.wrapper,
        isMiniModal ? "_2rko1tm3 _1reo15vq _18m915vq _16qs130s _4t3i1wug _k8m0wor5 _1oec15uc _6fl4indk" : $f5c1836cf94a50bb$var$styles.wrapperHeight,
        externalEmbed && $f5c1836cf94a50bb$var$styles.externalEmbed,
        $f5c1836cf94a50bb$var$stylesBorder[getBorderStyle()],
        fullScreen && shouldShowStagingArea && $f5c1836cf94a50bb$var$styles.withExternalStagingArea,
        isFullScreenModal && "_2rko12b0 _189ee4h9 _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _1bsb1osq _4t3i1osq"
    ]);
    let t4;
    if ($[18] !== renderInnerChildren) {
        t4 = renderInnerChildren();
        $[18] = renderInnerChildren;
        $[19] = t4;
    } else t4 = $[19];
    let t5;
    if ($[20] !== t3 || $[21] !== t4 || $[22] !== testId) {
        t5 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": testId,
            "data-rovo-chat-panel": t2,
            className: t3
        }, t4);
        $[20] = t3;
        $[21] = t4;
        $[22] = testId;
        $[23] = t5;
    } else t5 = $[23];
    return t5;
} : ({ testId: testId, children: children, isNav4Enabled: isNav4Enabled, mode: mode })=>{
    const isMiniModal = mode === (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL;
    const isFullScreenModal = mode === (0, $dPoYT.ConversationAssistantUIModes).FULL_SCREEN_MODAL && (0, $iDrrr.fg)('agent_session_experience_fg');
    const { externalEmbed: externalEmbed, fullScreen: fullScreen, elements: elements, isSplitLayout: isSplitLayout, splitLayoutInitialWidth: splitLayoutInitialWidth, splitLayoutMinWidth: splitLayoutMinWidth, splitLayoutAdjacentMinWidth: splitLayoutAdjacentMinWidth, splitLayoutStorageKey: splitLayoutStorageKey } = (0, $dSCNl.useUIConfig)();
    const { stagingAreaMode: stagingAreaMode } = (0, $8akfd.useStagingAreaState)();
    const renderInnerChildren = ()=>{
        if (!isSplitLayout || !(0, $iDrrr.fg)('agent_session_experience_fg')) return children;
        return /*#__PURE__*/ $cozmU.createElement((0, $2FUOC.SessionContextLayout), {
            isMiniModal: isMiniModal,
            initialWidth: splitLayoutInitialWidth,
            minWidth: splitLayoutMinWidth,
            adjacentMinWidth: splitLayoutAdjacentMinWidth,
            storageKey: splitLayoutStorageKey
        }, children);
    };
    const shouldShowStagingArea = stagingAreaMode === 'inline'; // Purely for FE team testing fullscreen where branch deploys are accessible
    // The use of localStorage and a private FF should make this safe, and it's our
    // best bet to improve dev velocity at the moment. Once Atlas has local consumption
    // we can remove this
    const fullscreenDebugEnabled = // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem('DEBUG_rovo_chat_fullscreen') === 'true' && (0, $iDrrr.fg)('rovo_chat_show_local_frontend_components');
    const shouldUseWrapperNav4Styles = isNav4Enabled;
    if (fullscreenDebugEnabled) return /*#__PURE__*/ $cozmU.createElement((0, $cK21K.default), {
        zIndex: 500
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        "data-rovo-chat-panel": "true",
        className: (0, $hekY6.default)([
            shouldUseWrapperNav4Styles ? $f5c1836cf94a50bb$var$styles.wrapperNav4 : $f5c1836cf94a50bb$var$styles.wrapper,
            isMiniModal ? "_2rko1tm3 _1reo15vq _18m915vq _16qs130s _4t3i1wug _k8m0wor5 _1oec15uc _6fl4indk" : $f5c1836cf94a50bb$var$styles.wrapperHeight,
            externalEmbed && $f5c1836cf94a50bb$var$styles.externalEmbed,
            $f5c1836cf94a50bb$var$styles.fullscreenDebug,
            $f5c1836cf94a50bb$var$stylesBorder.borderFullScreenDebug
        ])
    }, renderInnerChildren()));
    const getBorderStyle = ()=>{
        if (elements?.stagingAreaEnabled) return 'borderStagingArea';
        if (externalEmbed) return 'borderExternalEmbed';
        if (fullscreenDebugEnabled) // this is not possible because if condition above, but adding it here for completeness
        return 'borderFullScreenDebug';
        if (shouldUseWrapperNav4Styles) return 'borderNavV4';
        return 'borderNavV3';
    };
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        "data-rovo-chat-panel": "true",
        className: (0, $hekY6.default)([
            shouldUseWrapperNav4Styles ? $f5c1836cf94a50bb$var$styles.wrapperNav4 : $f5c1836cf94a50bb$var$styles.wrapper,
            isMiniModal ? "_2rko1tm3 _1reo15vq _18m915vq _16qs130s _4t3i1wug _k8m0wor5 _1oec15uc _6fl4indk" : $f5c1836cf94a50bb$var$styles.wrapperHeight,
            externalEmbed && $f5c1836cf94a50bb$var$styles.externalEmbed,
            $f5c1836cf94a50bb$var$stylesBorder[getBorderStyle()],
            fullScreen && shouldShowStagingArea && $f5c1836cf94a50bb$var$styles.withExternalStagingArea,
            isFullScreenModal && "_2rko12b0 _189ee4h9 _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _1bsb1osq _4t3i1osq"
        ])
    }, renderInnerChildren());
};
module.exports["MainWrapper"] = $f5c1836cf94a50bb$export$6661021c36f0a701;

});

parcelRegister("2FUOC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $7o2Oy = parcelRequire("7o2Oy");


var $iehIX = parcelRequire("iehIX");


var $axKZp = parcelRequire("axKZp");

const $0ddc8c1cb3dfb4b8$var$styles = {
    overlayHost: "_2rko1kw7 _kqswh2mm _1e0c1txw _2lx21bp4 _16jlkb7n _1tkeidpf"
};
const $0ddc8c1cb3dfb4b8$export$9a828967a77275b7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { children: children, isMiniModal: isMiniModal, initialWidth: initialWidth, minWidth: minWidth, adjacentMinWidth: adjacentMinWidth, storageKey: storageKey } = t0;
    const [presentation, setPresentation] = (0, $cozmU.useState)(null);
    const rightPanelExitHandlerRef = (0, $cozmU.useRef)(null);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>setPresentation(null);
        $[0] = t1;
    } else t1 = $[0];
    const closeSessionContext = t1;
    let t2;
    if ($[1] !== isMiniModal) {
        t2 = (requestedPresentation)=>{
            const nextPresentation = isMiniModal ? "drawer" : requestedPresentation;
            setPresentation(nextPresentation);
            return nextPresentation;
        };
        $[1] = isMiniModal;
        $[2] = t2;
    } else t2 = $[2];
    const openSessionContext = t2;
    let t3;
    if ($[3] !== openSessionContext || $[4] !== presentation) {
        t3 = {
            presentation: presentation,
            openSessionContext: openSessionContext,
            closeSessionContext: closeSessionContext,
            rightPanelExitHandlerRef: rightPanelExitHandlerRef
        };
        $[3] = openSessionContext;
        $[4] = presentation;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            $0ddc8c1cb3dfb4b8$var$styles.overlayHost
        ]);
        $[6] = t4;
    } else t4 = $[6];
    const t5 = presentation === "split";
    let t6;
    if ($[7] !== adjacentMinWidth || $[8] !== children || $[9] !== initialWidth || $[10] !== minWidth || $[11] !== storageKey || $[12] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $7o2Oy.SplitLayout), {
            initialWidth: initialWidth,
            minWidth: minWidth,
            adjacentMinWidth: adjacentMinWidth,
            storageKey: storageKey,
            isRightPanelVisible: t5,
            onAutoCollapse: closeSessionContext,
            rightPanelExitHandlerRef: rightPanelExitHandlerRef
        }, children);
        $[7] = adjacentMinWidth;
        $[8] = children;
        $[9] = initialWidth;
        $[10] = minWidth;
        $[11] = storageKey;
        $[12] = t5;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== presentation) {
        t7 = presentation === "drawer" && /*#__PURE__*/ $cozmU.createElement((0, $axKZp.SessionContextPanelDrawer), null);
        $[14] = presentation;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== t6 || $[17] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t4
        }, t6, t7);
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== t3 || $[20] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $iehIX.SplitViewContext).Provider, {
            value: t3
        }, t8);
        $[19] = t3;
        $[20] = t8;
        $[21] = t9;
    } else t9 = $[21];
    return t9;
} : ({ children: children, isMiniModal: isMiniModal, initialWidth: initialWidth, minWidth: minWidth, adjacentMinWidth: adjacentMinWidth, storageKey: storageKey })=>{
    const [presentation, setPresentation] = (0, $cozmU.useState)(null);
    const rightPanelExitHandlerRef = (0, $cozmU.useRef)(null);
    const closeSessionContext = (0, $cozmU.useCallback)(()=>setPresentation(null), []);
    const openSessionContext = (0, $cozmU.useCallback)((requestedPresentation)=>{
        const nextPresentation = isMiniModal ? 'drawer' : requestedPresentation;
        setPresentation(nextPresentation);
        return nextPresentation;
    }, [
        isMiniModal
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $iehIX.SplitViewContext).Provider, {
        value: {
            presentation: presentation,
            openSessionContext: openSessionContext,
            closeSessionContext: closeSessionContext,
            rightPanelExitHandlerRef: rightPanelExitHandlerRef
        }
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $0ddc8c1cb3dfb4b8$var$styles.overlayHost
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $7o2Oy.SplitLayout), {
        initialWidth: initialWidth,
        minWidth: minWidth,
        adjacentMinWidth: adjacentMinWidth,
        storageKey: storageKey,
        isRightPanelVisible: presentation === 'split',
        onAutoCollapse: closeSessionContext,
        rightPanelExitHandlerRef: rightPanelExitHandlerRef
    }, children), presentation === 'drawer' && /*#__PURE__*/ $cozmU.createElement((0, $axKZp.SessionContextPanelDrawer), null)));
};
module.exports["SessionContextLayout"] = $0ddc8c1cb3dfb4b8$export$9a828967a77275b7;

});

parcelRegister("axKZp", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $aRvnq = parcelRequire("aRvnq");


var $j72ee = parcelRequire("j72ee");


var $iMnC5 = parcelRequire("iMnC5");


var $iiDOK = parcelRequire("iiDOK");


var $Vl9MW = parcelRequire("Vl9MW");


var $6FfVp = parcelRequire("6FfVp");

const $579ae2552509f6a5$var$messages = (0, $kSwu1.defineMessages)({
    contextPanelLabel: {
        id: "ai-mate.conversation-assistant.session-context-panel-drawer.label-non-final",
        defaultMessage: "Context panel"
    },
    closeContextPanelLabel: {
        id: "ai-mate.conversation-assistant.session-context-panel-drawer.close-label-non-final",
        defaultMessage: "Hide context"
    }
});
const $579ae2552509f6a5$var$styles = {
    drawer: "_2rko1kw7 _kqswstnw _154ize3t _1xi2ze3t _94n5ze3t _1ltvze3t _1pbykb7n _1e0c1txw _2lx21bp4 _bfhkhp5a _16qs130s _1reo15vq _18m915vq",
    content: "_1e0c1txw _2lx21bp4 _16jlkb7n _1tkeidpf",
    toolbar: "_1e0c1txw _1o9zidpf _4cvr1h6o _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp",
    body: "_16jlkb7n _1tkeidpf"
}; /**
    * Session context overlay used when there is not room for a side-by-side split (narrow surfaces, the
    * mini-modal, or when reopening after a split auto-collapses). `MainWrapper` mounts it only while
    * drawer presentation is active. The opaque cover mounts instantly and the content animates in via
    * `SlideIn`, so the chat is never revealed mid-animation.
    */ 
const $579ae2552509f6a5$export$a00c723d48325325 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(8);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { closeSessionContext: closeSessionContext } = (0, $iiDOK.useSplitView)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($579ae2552509f6a5$var$messages.contextPanelLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== closeSessionContext || $[3] !== formatMessage) {
        t1 = /*#__PURE__*/ $cozmU.createElement((0, $j72ee.default), {
            enterFrom: "right",
            fade: "in",
            duration: "medium"
        }, (t2)=>{
            const { className: className, style: style, ref: ref } = t2;
            return /*#__PURE__*/ $cozmU.createElement("div", {
                ref: ref,
                className: (0, $hekY6.default)([
                    $579ae2552509f6a5$var$styles.content,
                    className
                ]),
                style: style
            }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $579ae2552509f6a5$var$styles.toolbar
            }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                testId: "conversation-assistant-session-context-panel-drawer-close-button",
                appearance: "subtle",
                isTooltipDisabled: false,
                label: formatMessage($579ae2552509f6a5$var$messages.closeContextPanelLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))),
                onClick: closeSessionContext,
                autoFocus: true
            })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $579ae2552509f6a5$var$styles.body
            }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
                fallback: /*#__PURE__*/ $cozmU.createElement((0, $6FfVp.SessionRightPanelSkeleton), null)
            }, /*#__PURE__*/ $cozmU.createElement((0, $Vl9MW.SessionRightPanelLazy), null))));
        });
        $[2] = closeSessionContext;
        $[3] = formatMessage;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== t0 || $[6] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $579ae2552509f6a5$var$styles.drawer,
            testId: "conversation-assistant-session-context-panel-drawer",
            role: "dialog",
            "aria-label": t0
        }, t1);
        $[5] = t0;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { closeSessionContext: closeSessionContext } = (0, $iiDOK.useSplitView)();
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $579ae2552509f6a5$var$styles.drawer,
        testId: "conversation-assistant-session-context-panel-drawer",
        role: "dialog",
        "aria-label": formatMessage($579ae2552509f6a5$var$messages.contextPanelLabel)
    }, /*#__PURE__*/ $cozmU.createElement((0, $j72ee.default), {
        enterFrom: "right",
        fade: "in",
        duration: "medium"
    }, ({ className: className, style: style, ref: ref })=>/*#__PURE__*/ $cozmU.createElement("div", {
            ref: ref,
            className: (0, $hekY6.default)([
                $579ae2552509f6a5$var$styles.content,
                className
            ]),
            style: style
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $579ae2552509f6a5$var$styles.toolbar
        }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            testId: "conversation-assistant-session-context-panel-drawer-close-button",
            appearance: "subtle",
            isTooltipDisabled: false,
            label: formatMessage($579ae2552509f6a5$var$messages.closeContextPanelLabel),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))),
            onClick: closeSessionContext,
            autoFocus: true
        })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $579ae2552509f6a5$var$styles.body
        }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
            fallback: /*#__PURE__*/ $cozmU.createElement((0, $6FfVp.SessionRightPanelSkeleton), null)
        }, /*#__PURE__*/ $cozmU.createElement((0, $Vl9MW.SessionRightPanelLazy), null))))));
};
module.exports["SessionContextPanelDrawer"] = $579ae2552509f6a5$export$a00c723d48325325;

});


//# sourceMappingURL=ObjectSidebarControl.791e65f8.js.map
